// REACT
import React, { useEffect, useState, useMemo } from 'react'
import ReactDOM from 'react-dom'
import { Icon } from 'semantic-ui-react'
// import { encode } from 'querystring';

// OPEN LAYERS
import Feature from 'ol/Feature'
import * as ol from 'ol'
import {
  Image as ImageLayer,
  Tile as TileLayer,
  Vector as VectorLayer,
  VectorTile as VectorTileLayer
} from 'ol/layer.js'
import {
  ImageWMS,
  OSM,
  TileArcGISRest,
  TileImage,
  Vector,
  XYZ
} from 'ol/source.js'
import MVT from 'ol/format/MVT'
import VectorTileSource from 'ol/source/VectorTile'
import stylefunction from 'ol-mapbox-style/dist/stylefunction'

//import {file as FileLoader} from "ol/featureloader.js";
import { GeoJSON, WKT } from 'ol/format.js'
import TileGrid from 'ol/tilegrid/TileGrid.js'
import Point from 'ol/geom/Point'
import Polygon from 'ol/geom/Polygon'
import { getTopLeft } from 'ol/extent.js'
import { easeOut } from 'ol/easing'
import {
  Fill,
  Stroke,
  Style,
  Circle as CircleStyle,
  Text as TextStyle
} from 'ol/style'
import { ScaleLine, FullScreen, Rotate, Zoom } from 'ol/control.js'
import { unByKey } from 'ol/Observable.js'
import { transform } from 'ol/proj.js'
import Projection from 'ol/proj/Projection.js'
import proj4 from 'proj4'
import { register } from 'ol/proj/proj4'
import { fromLonLat } from 'ol/proj'
import { getVectorContext } from 'ol/render'
import { KeyboardPan, KeyboardZoom } from 'ol/interaction.js'
// import {get as getProjection} from 'ol/proj';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faLayerGroup } from '@fortawesome/free-solid-svg-icons/faLayerGroup'

//OTHER
import { parseString } from 'xml2js'
import shortid from 'shortid'
import ShowMessage from './ShowMessage.jsx'
import ShowTerms from './ShowTerms.jsx'
import URLWindow from './URLWindow.jsx'
import ShowWindow from './ShowWindow.jsx'
import mainConfig from '../config.json'
import { InfoRow } from './InfoRow.jsx'
import blankImage from './images/blank.png'

import * as vHelpers from './vHelpers.js'
import * as helpers from './helpers.js'

// REGISTER CUSTOM PROJECTIONS
proj4.defs([
  [
    'EPSG:26917',
    '+proj=utm +zone=17 +ellps=GRS80 +datum=NAD83 +units=m +no_defs '
  ]
])
register(proj4)

proj4.defs([
  [
    'EPSG:5514',
    '+proj=krovak +lat_0=49.5 +lon_0=24.83333333333333 +alpha=30.28813972222222 +k=0.9999 +x_0=0 +y_0=0 +ellps=bessel +towgs84=589,76,480,0,0,0,0 +units=m +no_defs'
  ]
])
register(proj4)

//epsg.io/102067.js
//config = mainConfig;
// UTM NAD 83
const _nad83Proj = new Projection({
  code: 'EPSG:26917',
  extent: [194772.8107, 2657478.7094, 805227.1893, 9217519.4415]
})

export function registerCustomProjection(wkt, callback) {
  if (proj4.defs(`EPSG:${wkt}`)) callback()
  else {
    const epsgUrl = (wkt) => `https://epsg.io/${wkt}.proj4`
    httpGetText(epsgUrl(wkt), (projection) => {
      if (projection !== 'ERROR') {
        proj4.defs(`EPSG:${wkt}`, projection)
        register(proj4)
      }
      callback()
    })
  }
}
export function tryParseJSON(jsonString) {
  try {
    var obj = JSON.parse(jsonString)
    if (obj && typeof obj === 'object') {
      return obj
    }
  } catch (e) {}
  return false
}

export function sortByKey(array, key) {
  return array.sort(function (a, b) {
    var x = a[key]
    var y = b[key]
    return x < y ? -1 : x > y ? 1 : 0
  })
}
// APP STAT
export function addAppStat(type, description) {
  waitForLoad('settings', Date.now(), 30, () => {
    if (window.config.includeAppStats === false) return
    // IGNORE LOCAL HOST DEV
    // if (window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1") return;
    const build = (appName, version) => `${appName}-${version}`
    const appStatsTemplate = (build, type, description) =>
      `${window.config.appStatsUrl}${build}/${type}/${description}`
    let buildname = ''
    if (window.homepage) buildname += window.homepage
    if (window.version) {
      buildname = build(
        window.app ? window.app : window.location.pathname.split('/').join(''),
        window.version
      )
    }
    if (window.homepage) buildname += '-' + window.homepage
    if (buildname === '') buildname = 'Unknown'
    httpGetText(appStatsTemplate(buildname, type, description))
  })
}

// GLOW CONTAINER
export function glowContainer(id, color = 'blue') {
  const elem = document.getElementById(id)
  if (elem === undefined || elem === null) return
  const className = 'sc-glow-container-' + color
  elem.classList.add(className)
  setTimeout(function () {
    elem.classList.remove(className)
  }, 1000)
}

// MOBILE VIEW
export function isMobile() {
  if (window.innerWidth < 770) return true
  else return false
}

// SHOW CONTENT WINDOW
export function showWindow(
  contents,
  options = {
    title: 'Informácie',
    showFooter: false,
    mode: 'normal',
    hideScroll: false
  }
) {
  ReactDOM.render(
    <ShowWindow
      key={shortid.generate()}
      title={options.title}
      mode={options.mode}
      showFooter={options.showFooter}
      contents={contents}
      hideScroll={options.hideScroll}
      style={options.style}
    />,
    document.getElementById('map-modal-window')
  )
}

// SHOW URL WINDOW
export function showURLWindow(
  url,
  showFooter = false,
  mode = 'normal',
  honorDontShow = false,
  hideScroll = false
) {
  let isSameOrigin = true
  waitForLoad('settings', Date.now(), 30, () => {
    if (window.config.restrictOriginForUrlWindow) {
      if (url !== undefined)
        isSameOrigin =
          url.toLowerCase().indexOf(window.location.origin.toLowerCase()) !== -1
    }

    if (isSameOrigin) {
      ReactDOM.render(
        <URLWindow
          key={shortid.generate()}
          mode={mode}
          showFooter={showFooter}
          url={url}
          honorDontShow={honorDontShow}
          hideScroll={hideScroll}
        />,
        document.getElementById('map-modal-window')
      )
    } else {
      window.open(url, '_blank')
    }
  })
}

export function export_file(filename, content) {
  download(
    'data:text/plain;charset=utf-8,' + encodeURIComponent(content),
    filename
  )
}
// GET ARCGIS TILED LAYER
export function getArcGISTiledLayer(url) {
  return new TileLayer({
    source: new TileArcGISRest({
      url: url,
      crossOrigin: 'anonymous'
      // tileLoadFunction: function(tile, src) {
      //   var xhr = new XMLHttpRequest();

      //   // var to = null;
      //   // var handle = setTimeout(() => {
      //   //   to = "yes";
      //   //   return null;
      //   // }, 1000);
      //   // console.log(handle);
      //   xhr.open("GET", src);
      //   xhr.responseType = "arraybuffer";

      //   xhr.onload = function() {
      //     // console.log(handle);
      //     // console.log(to);

      //     var arrayBufferView = new Uint8Array(this.response);
      //     var blob = new Blob([arrayBufferView], { type: "image/png" });
      //     var urlCreator = window.URL || window.webkitURL;
      //     var imageUrl = urlCreator.createObjectURL(blob);
      //     tile.getImage().src = imageUrl;
      //   };
      //   xhr.send();
      // },
    }),
    crossOrigin: 'anonymous'
  })
}

export function getESRITileXYZLayer(url) {
  const rebuildParams = {
    sourceType: 'ESRITileXYZ',
    url: url
  }
  return new TileLayer({
    rebuildParams: rebuildParams,
    source: new XYZ({
      attributions:
        'Tiles © <a href="https://services.arcgisonline.com/ArcGIS/rest/services/World_Topo_Map/MapServer">ArcGIS</a>',
      url: url + '/tile/{z}/{y}/{x}',
      crossOrigin: 'anonymous'
    })
  })
}

export function getOSMTileXYZLayer(url) {
  const rebuildParams = {
    sourceType: 'OSMTileXYZ',
    url: url
  }
  return new TileLayer({
    rebuildParams: rebuildParams,
    source: new OSM({ url: url + '/{z}/{x}/{y}.png' }),
    crossOrigin: 'anonymous'
  })
}

export function getXYZLayer(url) {
  return new TileLayer({
    source: new XYZ({ url: url + '/{z}/{x}/{y}.png' }),
    crossOrigin: 'anonymous'
  })
}

export function getSimcoeTileXYZLayer(url) {
  const resolutions = [
    305.74811314055756, 152.87405657041106, 76.43702828507324,
    38.21851414253662, 19.10925707126831, 9.554628535634155, 4.77731426794937,
    2.388657133974685, 1.1943285668550503, 0.5971642835598172,
    0.29858214164761665, 0.1492252984505969
  ]
  const projExtent = window.map.getView().getProjection().getExtent()
  var tileGrid = new TileGrid({
    resolutions: resolutions,
    tileSize: [256, 256],
    origin: getTopLeft(projExtent)
    //origin: [-20037500.342787,20037378.342787 ]
    // origin: [-20037508.342787,20037508.342787 ]
  })

  const rebuildParams = {
    sourceType: 'SimcoeTileXYZ',
    url: url
  }
  var source = new TileImage({
    tileUrlFunction: function (tileCoord, pixelRatio, projection) {
      if (tileCoord === null) return undefined

      const z = tileCoord[0]
      const x = tileCoord[1]
      const y = tileCoord[2]

      //if ( z < 17 || x < 0 || y < 0) return undefined;

      return url + '/tile/' + z + '/' + y + '/' + x
    },
    tileGrid: tileGrid,
    crossOrigin: 'anonymous'
  })
  source.on('tileloaderror', function (event) {
    // BROWSER STILL KICKS OUT 404 ERRORS.  ANYBODY KNOW A WAY TO PREVENT THE ERRORS IN THE BROWSER?
    event.tile.getImage().src = blankImage

    // var tileLoadFunction = function(imageTile, src) {
    //   imageTile.getImage().src = blankImage;
    // };
    //  if (event.tile.tileLoadFunction_ !== tileLoadFunction) {
    //   event.tile.tileLoadFunction_ = tileLoadFunction;
    //   event.tile.load();
    // }
  })

  return new TileLayer({
    rebuildParams: rebuildParams,
    projection: 'EPSG:5514',
    //projection: 'EPSG:3857',
    //matrixSet: 'EPSG:3857',
    source: source,
    maxResolution: 400,
    useInterimTiles: true
  })
}

// GET OPEN STREET MAP LAYER
export function getOSMLayer() {
  const rebuildParams = {
    sourceType: 'OSM'
  }
  return new TileLayer({
    rebuildParams: rebuildParams,
    source: new OSM(),
    crossOrigin: 'anonymous'
  })
}
export function shouldCancelPopup(coord, startTime) {
  //HAS THE USER CLICKED ON SOMETHING ELSE?
  return (
    window.activeClick &&
    window.activeClick.time > startTime &&
    (window.activeClick.coordinates[0] !== coord[0] ||
      window.activeClick.coordinates[1] !== coord[1])
  )
}
export function getViewRotation() {
  var rotation = parseFloat(0)
  if (window.map === undefined) return rotation
  rotation = window.map.getView().getProperties().rotation
  return rotation * (180 / Math.PI)
}

export function updateWMSRotation() {
  const layers = window.map.getLayers()
  let currentRotation = getViewRotation()
  if (layers.array_.length > 0) {
    layers.forEach((layer) => {
      if (layer instanceof ImageLayer) {
        let source = layer.getSource()
        source.updateParams({ angle: currentRotation })
        layer.setSource(source)
      }
    })
    window.map.getView().setProperties({ rotation: 0 })
  }
}
// GET WMS Image Layer
export function getImageWMSLayer(
  serverURL,
  layers,
  serverType = 'geoserver',
  cqlFilter = null,
  zIndex = null,
  disableParcelClick = null
) {
  const rebuildParams = {
    sourceType: 'ImageWMS',
    url: serverURL,
    layers: layers,
    serverType: serverType,
    cqlFilter: cqlFilter,
    zIndex: zIndex,
    disableParcelClick: disableParcelClick
  }
  let imageLayer = new ImageLayer({
    rebuildParams: rebuildParams,
    visible: true,
    zIndex: zIndex,
    source: new ImageWMS({
      url: serverURL,
      params: {
        VERSION: '1.3.0',
        LAYERS: layers,
        TILED: true,
        cql_filter: cqlFilter
      },
      ratio: 1,
      serverType: serverType,
      crossOrigin: 'anonymous'
    })
  })

  const wfsUrlTemplate = (serverUrl, layer, cqlFilter) =>
    `${serverUrl}/wfs?service=wfs&version=2.0.0&request=GetFeature&typeNames=${layer}&outputFormat=application/json&cql_filter=${cqlFilter}`
  const wfsUrl = wfsUrlTemplate(serverURL.replace('/wms', ''), layers)

  const workspace = layers.split(':')[0]
  const layerNameOnly = layers.split(':')[1]
  const rootInfoTemplate = (serverUrl, workspace, layerNameOnly) =>
    `${serverUrl}/rest/workspaces/${workspace}/layers/${layerNameOnly}.json`
  const rootInfoUrl = rootInfoTemplate(
    serverURL.replace('/wms', ''),
    workspace,
    layerNameOnly
  )

  if (layerNameOnly === 'Assessment Parcel') disableParcelClick = false

  imageLayer.setProperties({
    wfsUrl: wfsUrl,
    name: layerNameOnly,
    rootInfoUrl: rootInfoUrl,
    disableParcelClick: disableParcelClick,
    tocDisplayName: layerNameOnly,
    queryable: true
  })
  return imageLayer
}

//GET VectorTie Layer
export function getVectorTileLayer(url) {
  let layer = new VectorTileLayer({
    renderMode: 'vector',
    reload: Infinity,
    declutter: true,
    //extent: extent,
    source: new VectorTileSource({
      attributions: 'LIO VectorTiles Test',
      format: new MVT(),
      url: url + '/tile/{z}/{y}/{x}.pbf',
      maxZoom: 26
      //rootPath: url + "/resources/styles/root.json",
      //spritePath: url + "/resources/sprites/sprite.json",
      //pngPath: url + "/resources/sprites/sprite.png",
    }),
    id: 'vTileLayer',
    tilePixelRatio: 8
  })
  //let rootPath= url + "/tile/{z}/{y}/{x}.pbf"; // rootPath for applySytle
  let rootPath = url + '/resources/styles/root.json'
  let spritePath = url + '/resources/sprites/sprite.json'
  let pngPath = url + '/resources/sprites/sprite.png'
  fetch(rootPath).then(function (response) {
    response.json().then(function (glStyle) {
      fetch(spritePath).then(function (response) {
        response.json().then(function (spriteData) {
          stylefunction(layer, glStyle, 'esri', undefined, spriteData, pngPath)
        })
      })
    })
  })

  return layer //StyledLayer is returned;
}

export function scaleToResolution(scale) {
  const DOTS_PER_INCH = 96
  const INCHES_PER_METER = 39.37
  const pointResolution = parseFloat(scale) / (DOTS_PER_INCH * INCHES_PER_METER)
  var projection = window.map.getView().getProjection()
  return pointResolution / projection.getMetersPerUnit()
}

// GET CURRENT MAP SCALE
export function getMapScale() {
  const DOTS_PER_INCH = 96
  const INCHES_PER_METER = 39.37
  var resolution = window.map.getView().getResolution()
  var projection = window.map.getView().getProjection()
  const pointResolution = projection.getMetersPerUnit() * resolution
  return Math.round(pointResolution * DOTS_PER_INCH * INCHES_PER_METER)
}

// SET CURRENT MAP SCALE
export function setMapScale(scale) {
  const DOTS_PER_INCH = 96
  const INCHES_PER_METER = 39.37
  const pointResolution = parseFloat(scale) / (DOTS_PER_INCH * INCHES_PER_METER)
  var projection = window.map.getView().getProjection()
  var resolution = pointResolution / projection.getMetersPerUnit()
  window.map.getView().setResolution(resolution)
}

// SHOW DISCLAIMER
export const messageColors = {
  gray: 'gray',
  green: 'green',
  blue: 'blue',
  red: 'red',
  yellow: 'yellow',
  orange: 'orange'
}
export function getHash(input) {
  return input.split('').reduce((a, b) => {
    a = (a << 5) - a + b.charCodeAt(0)
    return a & a
  }, 0)
}
export function showTerms(
  title = 'Terms and Condition',
  messageText = 'Message',
  url = '',
  color = messageColors.green,
  accept,
  decline,
  options = undefined
) {
  const domId = 'portal-root'
  const termsDomId = 'sc-show-terms-root'

  ReactDOM.render(
    <ShowTerms
      id={domId}
      key={termsDomId}
      title={title}
      message={messageText}
      color={color}
      url={url}
      onAcceptClick={accept}
      onDeclineClick={decline}
      options={options}
      onClose={(ref) => {
        try {
          ReactDOM.unmountComponentAtNode(ref.current.parentNode)
        } catch (err) {
          console.log(err)
        }
      }}
    />,
    document.getElementById('portal-root')
  )
}

// SHOW MESSAGE
export function showMessage(
  title = 'Info',
  messageText = 'Message',
  color = messageColors.green,
  timeout = 5000,
  hideButton = false
) {
  const domId = 'sc-show-message-content'
  var existingMsg = document.getElementById(domId)
  if (existingMsg !== undefined && existingMsg !== null) existingMsg.remove()
  try {
    ReactDOM.unmountComponentAtNode(
      document.getElementById('sc-sidebar-message-container')
    )
  } catch {}
  const message = ReactDOM.render(
    <ShowMessage
      id={domId}
      key={domId}
      title={title}
      message={messageText}
      color={color}
      hideButton={hideButton}
    />,
    document.getElementById('sc-sidebar-message-container'),
    () => {
      setTimeout(() => {
        try {
          ReactDOM.unmountComponentAtNode(
            document.getElementById('sc-sidebar-message-container')
          )
        } catch (err) {
          console.log(err)
        }
      }, timeout)
    }
  )

  //console.log(message);
  // setTimeout(() => {
  //   try {
  //     ReactDOM.unmountComponentAtNode(message.myRef.current.parentNode);
  //   } catch (err) {
  //     const domId = "sc-show-message-content";
  //     var existingMsg = document.getElementById(domId);
  //     if (existingMsg !== undefined && existingMsg !== null) existingMsg.remove();
  //     console.log(err);
  //   }
  // }, timeout);
}

export function searchArrayByKey(nameKey, myArray) {
  for (var i = 0; i < myArray.length; i++) {
    if (myArray[i].name === nameKey) {
      return myArray[i]
    }
  }
}

// GET URL PARAMETER
export function getURLParameter(
  parameterName,
  decoded = true,
  caseSensitive = false
) {
  const queryString = window.location.search
  if (queryString.length < 1) return null
  const urlParams = new URLSearchParams(
    caseSensitive ? queryString : queryString.toLowerCase()
  )
  const param = urlParams.get(
    caseSensitive ? parameterName : parameterName.toLowerCase()
  )
  if (param === null) return null

  if (decoded) return param
  else return encodeURIComponent(param)
}

// HTTP GET (NO WAITING)
export function httpGetText(url, callback) {
  return fetch(url)
    .then((response) => {
      if (!response.ok) {
        throw new Error('Network response was not ok')
      }
      return response.text()
    })
    .then((responseText) => {
      // CALLBACK WITH RESULT
      if (callback !== undefined) callback(responseText)
    })
    .catch((error) => {
      // Handle the specific 'Failed to fetch' error differently if needed
      if (error.message.includes('Failed to fetch')) {
        console.error(
          'There was an issue fetching the resource. This might be due to network problems or CORS policy.'
        )
      } else {
        console.error(url, error)
      }

      // Uncomment the next line if you wish to retry with a different URL
      // httpGetText(url.replace("opengis.simcoe.ca", "opengis2.simcoe.ca"), callback);

      if (callback !== undefined) callback()
    })
}

// HTTP GET (NO WAITING)
export function httpGetTextWithParams(url, params = undefined, callback) {
  return fetch(url, params)
    .then((response) => {
      if (!response.ok) {
        throw new Error('Network response was not ok')
      }
      return response.text()
    })
    .then((responseText) => {
      // CALLBACK WITH RESULT
      if (callback !== undefined) callback(responseText)
    })
    .catch((error) => {
      // Handle the specific 'Failed to fetch' error differently if needed
      if (error.message.includes('Failed to fetch')) {
        console.error(
          'There was an issue fetching the resource. This might be due to network problems or CORS policy.'
        )
      } else {
        console.error(url, error)
      }

      // Uncomment the next line if you wish to retry with a different URL
      // httpGetTextWithParams(url.replace("opengis.simcoe.ca", "opengis2.simcoe.ca"), params, callback);

      if (callback !== undefined) callback()
    })
}

// HTTP GET WAIT
export async function httpGetTextWait(url, callback) {
  let data = await fetch(url)
    .then((response) => {
      const resp = response.text()
      return resp
    })
    .catch((err) => {
      console.log('Error: ', err)
    })
  if (callback !== undefined) {
    callback(data)
  }
  return data
}

// GET JSON (NO WAITING)
export function getJSON(url, callback) {
  return fetch(url)
    .then((response) => response.json())
    .then((responseJson) => {
      // CALLBACK WITH RESULT
      if (callback !== undefined) callback(responseJson)
    })
    .catch((error) => {
      console.error('Error: ', error, 'URL:', url)
    })
}

export function getJSON_callback(url, callback) {
  console.log('getJSON')
  return fetch(url)
    .then((response) => response.json())
    .then((responseJson) => {
      // CALLBACK WITH RESULT
      if (callback !== undefined) callback(responseJson)
    })
    .catch((error) => {
      // console.error("Error: ", error, "URL:", url);
      console.log('Trying again...')
      callback()
    })
}

// GET JSON (NO WAITING)
export function getJSONWithParams(url, params = undefined, callback) {
  return fetch(url, params)
    .then((response) => response.json())
    .then((responseJson) => {
      // CALLBACK WITH RESULT
      if (callback !== undefined) callback(responseJson)
    })
    .catch((error) => {
      console.error('Error: ', error, 'URL:', url)
    })
}
// GET JSON WAIT
export async function getJSONWaitWithParams(url, params = undefined, callback) {
  let data = await fetch(url, params)
    .then((res) => {
      const resp = res.json()
      return resp
    })
    .catch((err) => {
      console.log('Error: ', err, 'URL:', url)
    })
  if (callback !== undefined) {
    callback(data)
  }

  return await data
}

export function getObjectFromXMLUrl(url, callback) {
  return fetch(url)
    .then((response) => response.text())
    .then((responseText) => {
      // CALLBACK WITH RESULT
      if (callback !== undefined) {
        parseString(responseText, function (err, result) {
          callback(result)
        })
      }
    })
    .catch((error) => {
      console.error(error)
    })
}

export function isParcelClickEnabled() {
  // READ INFO FROM LOCAL STORAGE (GLOBAL SETTING)

  // FOR NOW JUST RETURN
  return window.disableParcelClick
}

//https://opengis.simcoe.ca/geoserver/wfs?service=wfs&version=2.0.0&request=GetFeature&typeNames=simcoe:Bag%20Tag%20Locations&outputFormat=application/json
export function getWFSVectorSource(
  serverUrl,
  layerName,
  callback,
  sortField = ''
) {
  const wfsUrlTemplate = (serverURL, layerName, sortField) =>
    `${serverURL}wfs?service=wfs&version=2.0.0&request=GetFeature&typeNames=${layerName}&outputFormat=application/json&sortBy=${sortField}`
  const wfsUrl = wfsUrlTemplate(serverUrl, layerName, sortField)
  getJSON(wfsUrl, (result) => {
    const geoJSON = new GeoJSON().readFeatures(result)
    var vectorSource = new Vector({ features: geoJSON })
    callback(vectorSource)
  })
}

//https://opengis.simcoe.ca/geoserver/wfs?service=wfs&version=2.0.0&request=GetFeature&typeNames=simcoe:Bag%20Tag%20Locations&outputFormat=application/json
export function getWFSGeoJSON(
  serverUrl,
  layerName,
  callback,
  sortField = null,
  extent = null,
  cqlFilter = null,
  count = null,
  featureID = null
) {

  // SORTING
  let additionalParams = ''
  if (sortField !== null) additionalParams += '&sortBy=' + sortField

  // BBOX EXTENT
  if (extent !== null && (cqlFilter === null || cqlFilter.length === 0)) {
    const extentString =
      extent[0] + ',' + extent[1] + ',' + extent[2] + ',' + extent[3]
    additionalParams += '&bbox=' + extentString
  }

  // ATTRIBUTE WHERECLAUSE
  if (featureID !== null && featureID.length !== 0) {
    const trimID = featureID.toString().replace(/^[^-]*-uid-/, '')
    additionalParams += '&featureID=' + trimID
    if (extent !== null) {
      const extentString =
        extent[0] + ',' + extent[1] + ',' + extent[2] + ',' + extent[3]
      additionalParams += ' AND BBOX(geom, ' + extentString + ')'
    }
  } else {
    // ATTRIBUTE WHERECLAUSE
    if (cqlFilter !== null && cqlFilter.length !== 0) {
      additionalParams += '&CQL_FILTER=' + cqlFilter
      if (extent !== null) {
        const extentString =
          extent[0] + ',' + extent[1] + ',' + extent[2] + ',' + extent[3]
        additionalParams += ' AND BBOX(geom, ' + extentString + ')'
      }
    }
  }

  // COUNT
  if (count !== null) additionalParams += '&count=' + count

  // USE TEMPLATE FOR READABILITY
  const wfsUrlTemplate = (serverURL, layerName) =>
    `${serverURL}wfs?service=wfs&version=2.0.0&request=GetFeature&typeNames=${layerName}&outputFormat=application/json`
  const wfsUrl = wfsUrlTemplate(serverUrl, layerName) + additionalParams
  // getJSON(wfsUrl, (result) => {
  getJSON_callback(wfsUrl, (result) => {
    console.log('result z getWFSGeoJSON', result)
    if (!result || result.features.length === 0) {
      callback([])
      return
    }
    result.features[0].properties['orig_geom_name'] =
      result.features[0].geometry_name
    const geoJSON = new GeoJSON().readFeatures(result)
    callback(geoJSON)
  })
}

export async function postWFSGeoJSON(
  serverUrl,
  layerName,
  sortField = null,
  extent = null,
  cqlFilter = null,
  count = null,
  featureID = null
) {
  console.log('in postWFSGeoJSON')
  let additionalParams = {}

  if (sortField !== null) additionalParams['sortBy'] = sortField
  if (extent !== null) {
    const extentString =
      extent[0] + ',' + extent[1] + ',' + extent[2] + ',' + extent[3]
    additionalParams['bbox'] = extentString
  }
  if (featureID !== null) {
    const trimID = featureID.toString().replace(/^[^-]*-uid-/, '')
    additionalParams['featureID'] = trimID
  }
  if (cqlFilter !== null) additionalParams['cql_filter'] = cqlFilter
  if (count !== null) additionalParams['count'] = count

  const wfsUrlTemplate = (serverURL, layerName) => `${serverURL}wfs`

  const wfsUrl = wfsUrlTemplate(serverUrl, layerName)

  const payload = {
    service: 'wfs',
    version: '2.0.0',
    request: 'GetFeature',
    typeNames: layerName,
    outputFormat: 'application/json',
    ...additionalParams
  }

  const response = await fetch(wfsUrl, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    body: new URLSearchParams(payload)
  })

  const data = await response.json()

  if (data.features.length === 0) {
    return []
  }

  data.features[0].properties['orig_geom_name'] = data.features[0].geometry_name
  const geoJSON = new GeoJSON().readFeatures(data)

  return geoJSON
}

export function getExtWFSGeoJSON(
  serverUrl,
  layerName,
  xmlFilter = null,
  featureID = null,
  sortField = null,
  extent = null,
  count = null,
  outputFormat = null,
  callback
) {
  console.log('in getExtWFSGeoJSON')

  // SORTING
  let additionalParams = ''
  // if (sortField !== null) additionalParams += "&sortBy=" + sortField;

  // BBOX EXTENT
  if (extent !== null && (xmlFilter === null || xmlFilter.length === 0)) {
    const extentString =
      extent[0] + ',' + extent[1] + ',' + extent[2] + ',' + extent[3]
    additionalParams += '&bbox=' + extentString
  }

  // ATTRIBUTE WHERECLAUSE
  if (featureID !== null && featureID.length !== 0) {
    const trimID = featureID.toString().replace(/^[^-]*-uid-/, '')
    additionalParams += '&featureID=' + trimID
  } else if (xmlFilter !== null && xmlFilter.length !== 0) {
    // additionalParams += "&filter=" + encode(xmlFilter);
    additionalParams += '&filter=' + encodeURIComponent(xmlFilter)
  }

  if (extent !== null) {
    const extentString =
      extent[0] + ',' + extent[1] + ',' + extent[2] + ',' + extent[3]
    additionalParams += ' AND BBOX(geom, ' + extentString + ')'
  }

  // Coordinate System
  // additionalParams += "&srsName=EPSG:5514";

  // COUNT
  if (count !== null) additionalParams += '&count=' + count

  // USE TEMPLATE FOR READABILITY
  const wfsUrlTemplate = (serverURL, layerName, srsName) =>
    `${serverURL}?service=wfs&version=2.0.0&request=GetFeature&typeNames=${layerName}&outputFormat=${outputFormat}&srsName=${srsName}`
  const wfsUrl =
    wfsUrlTemplate(serverUrl, layerName, 'EPSG:5514') + additionalParams

  // getJSON(wfsUrl, (result) => {
  //   if (result.features.length === 0) {
  //     callback([]);
  //     return;
  //   }
  //   result.features[0].properties["orig_geom_name"] =
  //     result.features[0].geometry_name;
  //   const geoJSON = new GeoJSON().readFeatures(result);

  //   callback(geoJSON);
  // });

  getJSON(wfsUrl, (result) => {
    if (result.features.length === 0) {
      callback([])
      return
    }

    // if (result && !Array.isArray(result)) {
    //   result = [result];
    // }

    result.features[0].properties['orig_geom_name'] =
      result.features[0].geometry_name

    // Transformácia súradníc
    // result.features.forEach(feature => {
    //   console.log("feature", feature);
    //   console.log("feature.geometry", feature.geometry);

    //   if (feature.geometry && feature.geometry.coordinates) {
    //     feature.geometry.coordinates = feature.geometry.coordinates.map(coordinateArray1 => {
    //       return coordinateArray1.map(coordinateArray2 => {
    //         return coordinateArray2.map(singleCoordinate => {
    //           return proj4('EPSG:4326', 'EPSG:5514', singleCoordinate);
    //         });
    //       });
    //     });
    //   }
    // });
    // Transformácia súradníc
    result.features.forEach((feature) => {
      if (feature.geometry && feature.geometry.coordinates) {
        if (feature.geometry && feature.geometry.coordinates) {
          switch (feature.geometry.type) {
            case 'Point':
              feature.geometry.coordinates = proj4(
                'EPSG:4326',
                'EPSG:5514',
                feature.geometry.coordinates
              )
              break
            case 'LineString':
            case 'MultiPoint':
              feature.geometry.coordinates = feature.geometry.coordinates.map(
                (singleCoordinate) => {
                  return proj4('EPSG:4326', 'EPSG:5514', singleCoordinate)
                }
              )
              break
            case 'Polygon':
            case 'MultiLineString':
              feature.geometry.coordinates = feature.geometry.coordinates.map(
                (coordinateArray) => {
                  return coordinateArray.map((singleCoordinate) => {
                    return proj4('EPSG:4326', 'EPSG:5514', singleCoordinate)
                  })
                }
              )
              break
            case 'MultiPolygon':
              feature.geometry.coordinates = feature.geometry.coordinates.map(
                (coordinateArray1) => {
                  return coordinateArray1.map((coordinateArray2) => {
                    return coordinateArray2.map((singleCoordinate) => {
                      return proj4('EPSG:4326', 'EPSG:5514', singleCoordinate)
                    })
                  })
                }
              )
              break
          }
        }
      }
    })

    const geoJSON = new GeoJSON().readFeatures(result)
    callback(geoJSON)
  })
}

export function getAttsFromGeoserver(
  serverUrl,
  layerName,
  callback,
  count = 1
) {
  // SORTING
  let additionalParams = ''
  // COUNT
  if (count !== null) additionalParams += '&count=' + count
  // USE TEMPLATE FOR READABILITY
  const wfsUrlTemplate = (serverURL, layerName) =>
    `${serverURL}wfs?service=wfs&version=2.0.0&request=GetFeature&typeNames=${layerName}&outputFormat=application/json`
  const wfsUrl = wfsUrlTemplate(serverUrl, layerName) + additionalParams
  getJSON(wfsUrl, (result) => {
    const geoJSON = new GeoJSON().readFeatures(result)
    callback(geoJSON)
  })
}

export function getAttsFromUrl(url, callback) {
  console.log('kontrola url z getAttsFromUrl', url)
  // USE TEMPLATE FOR READABILITY
  const wfsUrlTemplate = (url) =>
    `${url}/wfs?service=wfs&version=2.0.0&request=GetFeature&count=1&outputFormat=GEOJSON`
  // `${url}wfs?service=wfs&version=2.0.0&request=GetFeature&count=1&typeNames=${layerName}&outputFormat=application/json`;
  const wfsUrl = wfsUrlTemplate(url)
  //   const wfsUrl = wfsUrlTemplate(url, layerName) + additionalParams;
  getJSON(wfsUrl, (result) => {
    const geoJSON = new GeoJSON().readFeatures(result)
    callback(geoJSON)
  })
}
export function getAttsFromArcgisServer(layer, callback) {
  console.log('kontrola url z getAttsFromArcgisServer', layer)

  const url = layer.get('rootInfoUrl')
  const token = layer.get('secureKey')

  getJSONWait(
    url + (token !== '' ? '?token=' + token + '&f=json' : '?f=json'),
    (result) => {
      window.arcgisfields = result.fields
      let objk = result.fields.map((obj) => {
        let ret = {}
        ret.field = obj.name
        ret.alias = obj.alias
        return ret
      })
      callback(objk)
    }
  )
}

export function getTypenameFromArcgis(wfs_url, callback) {
  console.log('getTypenameFromArcgis', wfs_url)

  // let wfs_url = url.replace(/wms|WMS/g, "wfs");
  // const wfs_url = url.getUrl().replace(/wms/i, "wfs") || url.replace(/wms/i, "wfs");
  const getCapabilitiesUrl = `${wfs_url}?SERVICE=WFS&VERSION=2.0.0&REQUEST=GetCapabilities`

  fetch(getCapabilitiesUrl)
    .then((response) => response.text())
    .then((capabilitiesXml) => {
      var parser = new DOMParser()
      var xmlDoc = parser.parseFromString(capabilitiesXml, 'application/xml')
      var typename =
        xmlDoc.getElementsByTagName('wfs:Name')[0].childNodes[0].nodeValue
      callback(typename)
    })
    .catch((error) => {
      console.error('Chyba pri získavaní typename:', error)
      callback(undefined)
    })
}

// esri services
export function getAttsFromArcgis(url, typename, callback) {
  console.log('url z getAttsFromArcgisServer', url)

  // Vytvorenie URL pre GetFeature
  const getFeatureUrl = `${url}?request=GetFeature&service=WFS&typename=${typename}&outputFormat=GEOJSON&count=1`

  // Dopyt na získanie údajov z GetFeature
  getJSONWait(getFeatureUrl)
    .then((result) => {
      const featureProps = result['features'][0].properties
      callback(Object.keys(featureProps))
    })
    .catch((error) => {
      console.error('Chyba pri spracovaní dopytov:', error)
    })
}

export function getArcgisGeoJSON(
  layer,
  userQuery,
  geometry,
  spatialRel,
  geometrytype,
  callback
) {
  console.log('layer z getArcgisGeoJSON', layer)

  const url = layer.get('rootInfoUrl')
  const token = layer.get('secureKey')

  let searchquery = ''

  if (geometry !== null) {
    searchquery =
      token !== ''
        ? '/query?where=&text=&objectIds=&time=&geometry=' +
          encodeURIComponent(JSON.stringify(geometry)) +
          '&geometryType=' +
          geometrytype +
          '&inSR=&spatialRel=' +
          spatialRel +
          '&distance=&units=esriSRUnit_Kilometer&relationParam=&outFields=*&returnGeometry=true&returnTrueCurves=false&maxAllowableOffset=&geometryPrecision=&outSR=%7B++%22wkid%22+%3A+102067%2C++%22latestWkid%22+%3A+5514%7D&havingClause=&returnIdsOnly=false&returnCountOnly=false&orderByFields=&groupByFieldsForStatistics=&outStatistics=&returnZ=false&returnM=false&gdbVersion=&historicMoment=&returnDistinctValues=false&resultOffset=&resultRecordCount=&returnExtentOnly=false&datumTransformation=&parameterValues=&rangeValues=&quantizationParameters=&featureEncoding=esriDefault&f=geojson&token=' +
          token
        : ''
  } else {
    searchquery =
      token !== ''
        ? '/query?where=' +
          userQuery +
          "&outFields=*&outSR=%7B++'wkid'+%3A+102067%2C++'latestWkid'+%3A+5514%7D&returnGeometry=true&returnTrueCurves=false&returnIdsOnly=false&returnCountOnly=false&orderByFields=&returnZ=false&returnM=false&returnDistinctValues=false&returnExtentOnly=false&f=geojson&token=" +
          token
        : '/query?where=' +
          userQuery +
          '&outFields=*&returnGeometry=true&returnTrueCurves=false&returnIdsOnly=false&returnCountOnly=false&orderByFields=&returnZ=false&returnM=false&returnDistinctValues=false&returnExtentOnly=false&f=geojson'
    // searchquery = (token !== "" ? "/query?where=" + userQuery + "&outFields=*&outSR=%7B++'wkid'+%3A+102067%2C++'latestWkid'+%3A+5514%7D&returnGeometry=true&returnTrueCurves=false&returnIdsOnly=false&returnCountOnly=false&orderByFields=&returnZ=false&returnM=false&returnDistinctValues=false&returnExtentOnly=false&f=geojson&token=" + token : "/query?where=" + userQuery + "&outFields=*&returnGeometry=true&returnTrueCurves=false&returnIdsOnly=false&returnCountOnly=false&orderByFields=&returnZ=false&returnM=false&returnDistinctValues=false&returnExtentOnly=false&f=geojson");
  }

  getJSONWait(url + searchquery, (result) => {
    if (result.features.length === 0) {
      callback([])
      return
    }
    result.features[0].properties['orig_geom_name'] =
      result.features[0].geometry_name

    result.features.forEach((feature, index) => {
      feature.properties['esri_id'] = feature.id
    })

    const geoJSON = new GeoJSON().readFeatures(result)
    callback(geoJSON)
    //callback(result);
  })
}

// GET JSON WAIT
export async function getJSONWait(url, callback) {
  let data = await fetch(url)
    .then((res) => {
      const resp = res.json()
      //console.log(resp);
      return resp
    })
    .catch((err) => {
      console.log('Error: ', err, 'URL:', url)
    })
  if (callback !== undefined) {
    //console.log(data);
    callback(data)
  }

  return await data
}

export function getUniqueValuesFromGeoserver(
  serverUrl,
  layerName,
  attribute,
  callback
) {
  // USE TEMPLATE FOR READABILITY
  const wfsUrlTemplate = (url, layerName, attribute) =>
    `${url}wfs?service=wfs&version=2.0.0&request=GetFeature&typeNames=${layerName}&propertyName=${encodeURIComponent(
      attribute
    )}&sortBy=${encodeURIComponent(attribute)}&outputFormat=application/json`
  const wfsUrl = wfsUrlTemplate(serverUrl, layerName, attribute)

  getJSON_callback(wfsUrl, (result) => {
    if (!result) {
      callback([])
      return
    }
    const uniqueValues = [
      ...new Set(
        result.features.map((feature) => feature.properties[attribute])
      )
    ]
    const valueList = vHelpers.arrayToDictionary3(uniqueValues)
    callback(valueList)
  })
}
export function getUniqueValuesFromArcgisServer(layer, attribute, callback) {
  const url = layer.get('rootInfoUrl')
  const token = layer.get('secureKey')
  getJSONWait(
    url +
      (token !== ''
        ? '/query?where=1%3D1&outFields=' +
          attribute +
          '&returnGeometry=false&returnTrueCurves=false&returnIdsOnly=false&returnCountOnly=false&orderByFields=' +
          attribute +
          '&returnZ=false&returnM=false&returnDistinctValues=true&returnExtentOnly=false&f=json&token=' +
          token
        : '/query?where=1%3D1&outFields=' +
          attribute +
          '&returnGeometry=false&returnTrueCurves=false&returnIdsOnly=false&returnCountOnly=false&orderByFields=' +
          attribute +
          '&returnZ=false&returnM=false&returnDistinctValues=true&returnExtentOnly=false&?f=json'),
    (result) => {
      let uniqueValues = []
      result.features.forEach((obj) => {
        uniqueValues.push(obj.attributes[attribute])
      })
      const valueList = vHelpers.arrayToDictionary3(uniqueValues)
      callback(valueList)
    }
  )
}

export function getUniqueValuesFromUrl(url, typename, attribute, callback) {

  const wfsUrl = `${url}?request=GetFeature&service=WFS&outputFormat=GEOJSON&typeNames=${typename}&propertyName=${attribute}&orderBy=${attribute}`

  fetch(wfsUrl)
    .then((response) => response.text())
    .then((text) => {
      // Odstránime zbytočné čiarky za hodnotami typu geometrie, ako "Point" alebo "MultiPolygon"
      const correctedText = text.replace(/\"type\":\"[a-zA-Z]+\",}/g, (match) =>
        match.replace(',}', '}')
      )
      return JSON.parse(correctedText)
    })
    .then((result) => {
      // Extrahujeme hodnoty z vlastností
      const uniqueValues = [
        ...new Set(
          result.features.map((feature) => feature.properties[attribute])
        )
      ]
      // Predpokladám, že vHelpers.arrayToDictionary3 je definovaná korektne
      const valueList = vHelpers.arrayToDictionary3(uniqueValues)
      callback(valueList)
    })
    .catch((error) => {
      console.error('Chyba pri načítavaní údajov:', error)
    })
}

// export function getUniqueValuesFromUrl(
//     url,
//     attribute,
//     callback
//   ) {
//     // USE TEMPLATE FOR READABILITY
//     console.log("in get", url, attribute)

//     const wfsUrlTemplate = (url) =>
//     `${url}&propertyName=${attribute}&orderBy=${attribute}`;
//     // `${url}wfs?service=wfs&version=2.0.0&request=GetFeature&outputFormat=GEOJSON&propertyName=${attribute}&orderBy=${attribute}`;
//     // `${url}wfs?service=wfs&version=2.0.0&request=GetFeature&count=1&typeNames=${layerName}&outputFormat=application/json`;
//   const wfsUrl = wfsUrlTemplate(url);
//     console.log("url z getUniqueValuesFromUrl", wfsUrl)
//     getJSON(wfsUrl, (result) => {
//         const uniqueValues = [...new Set(result.features.map(feature => feature.properties[attribute]))];
//         const valueList = vHelpers.arrayToDictionary3(uniqueValues);
//         callback(valueList);
//         });
//   }

export function getWFSGeoJSON_vs(
  serverUrl,
  layerName,
  callback,
  sortField = null,
  extent = null,
  cqlFilter = null,
  count = 1
) {
  // SORTING
  let additionalParams = ''
  if (sortField !== null) additionalParams += '&sortBy=' + sortField

  // BBOX EXTENT
  if (extent !== null && (cqlFilter === null || cqlFilter.length === 0)) {
    const extentString =
      extent[0] + ',' + extent[1] + ',' + extent[2] + ',' + extent[3]
    additionalParams += '&bbox=' + extentString
  }

  // ATTRIBUTE WHERECLAUSE
  if (cqlFilter !== null && cqlFilter.length !== 0) {
    additionalParams += '&cql_filter=' + cqlFilter
    if (extent !== null) {
      const extentString =
        extent[0] + ',' + extent[1] + ',' + extent[2] + ',' + extent[3]
      additionalParams += ' AND BBOX(geom, ' + extentString + ')'
    }
  }

  // COUNT
  if (count !== null) additionalParams += '&count=' + count

  // USE TEMPLATE FOR READABILITY
  const wfsUrlTemplate = (serverURL, layerName) =>
    `${serverURL}wfs?service=wfs&version=2.0.0&request=GetFeature&typeNames=${layerName}&outputFormat=application/json`
  const wfsUrl = wfsUrlTemplate(serverUrl, layerName) + additionalParams
  console.log('wfs', wfsUrl)
  getJSON(wfsUrl, (result) => {
    const geoJSON = new GeoJSON().readFeatures(result)
    callback(geoJSON)
  })
}
export function getWFSGeoJSON_vs2(
  url,
  callback,
  sortField = null,
  extent = null,
  cqlFilter = null,
  count = 1
) {
  // SORTING
  let additionalParams = ''
  if (sortField !== null) additionalParams += '&sortBy=' + sortField

  // BBOX EXTENT
  if (extent !== null && (cqlFilter === null || cqlFilter.length === 0)) {
    const extentString =
      extent[0] + ',' + extent[1] + ',' + extent[2] + ',' + extent[3]
    additionalParams += '&bbox=' + extentString
  }

  // ATTRIBUTE WHERECLAUSE
  if (cqlFilter !== null && cqlFilter.length !== 0) {
    additionalParams += '&cql_filter=' + cqlFilter
    if (extent !== null) {
      const extentString =
        extent[0] + ',' + extent[1] + ',' + extent[2] + ',' + extent[3]
      additionalParams += ' AND BBOX(geom, ' + extentString + ')'
    }
  }

  // COUNT
  if (count !== null) additionalParams += '&count=' + count

  // USE TEMPLATE FOR READABILITY
  console.log('wfs', url)
  getJSON(url, (result) => {
    const geoJSON = new GeoJSON().readFeatures(result)
    callback(geoJSON)
  })
}

// export function getWFSLayerRecordCount(serverUrl, layerName, callback) {

//   console.log("getWFSLayerRecordCount");
//   console.log("layerName", layerName);

//   const recordCountUrlTemplate = (serverURL, layerName) => `${serverURL}wfs?REQUEST=GetFeature&VERSION=1.1&typeName=${layerName}&RESULTTYPE=hits`;
//   const recordCountUrl = recordCountUrlTemplate(serverUrl, layerName);
//   console.log("recordCountUrl", recordCountUrl)

//   getObjectFromXMLUrl(recordCountUrl, (result) => {
//     console.log("getObjectFromXMLUrl", result["wfs:FeatureCollection"]["$"].numberOfFeatures)
//     callback(result["wfs:FeatureCollection"]["$"].numberOfFeatures);
//   });

// }

// predosla funkcia neratala s filtrom, vudy brala pocet vsetkych features. tu pridam filter
export function getWFSLayerRecordCount(
  serverUrl,
  layerName,
  cqlFilter,
  callback
) {

  const recordCountUrlTemplate = (serverURL, layerName, cqlFilter) =>
    `${serverURL}wfs?REQUEST=GetFeature&VERSION=1.1&typeName=${layerName}&RESULTTYPE=hits&cql_filter=${cqlFilter}`
  const recordCountUrl = recordCountUrlTemplate(serverUrl, layerName, cqlFilter)
  console.log('recordCountUrl', recordCountUrl)

  getObjectFromXMLUrl(recordCountUrl, (result) => {
    console.log(
      'getObjectFromXMLUrl',
      result['wfs:FeatureCollection']['$'].numberOfFeatures
    )
    callback(result['wfs:FeatureCollection']['$'].numberOfFeatures)
  })
}

export function getWFSLayerRecordCountExt(
  serverUrl,
  layerName,
  cqlFilter,
  callback
) {
  console.log('cqlFilter', cqlFilter)

  const recordCountUrlTemplate = (serverURL, layerName, cqlFilter) =>
    `${serverURL}?REQUEST=GetFeature&VERSION=1.1&typeName=${layerName}&RESULTTYPE=hits&filter=${cqlFilter}`
  const recordCountUrl = recordCountUrlTemplate(serverUrl, layerName, cqlFilter)
  console.log('recordCountUrl', recordCountUrl)

  getObjectFromXMLUrl(recordCountUrl, (result) => {
    console.log(
      'getObjectFromXMLUrl',
      result['wfs:FeatureCollection']['$'].numberOfFeatures
    )
    callback(result['wfs:FeatureCollection']['$'].numberOfFeatures)
  })
}

export function getExtWFSLayerRecordCount(
  serverUrl,
  layerName,
  filter,
  callback
) {
  const recordCountUrlTemplate = (serverURL, layerName, filter) =>
    `${serverURL}?REQUEST=GetFeature&VERSION=2.0.0&SERVICE=WFS&typeName=${layerName}&RESULTTYPE=hits&filter=${filter}`
  const recordCountUrl = recordCountUrlTemplate(serverUrl, layerName, filter)

  fetch(recordCountUrl)
    .then((response) => response.text())
    .then((responseText) => {
      // CALLBACK WITH RESULT
      if (callback !== undefined) {
        parseString(responseText, function (err, result) {
          callback(result['wfs:FeatureCollection']['$'].numberMatched)
        })
      }
    })
}

export function getWFSLayerRecordCount_post(
  serverUrl,
  layerName,
  cqlFilter,
  featureID,
  callback
) {
  var myHeaders = new Headers()
  myHeaders.append('Content-Type', 'application/x-www-form-urlencoded')
  myHeaders.append(
    'Cookie',
    'GS_FLOW_CONTROL=GS_CFLOW_-1012a144:1847ab644b9:-6992'
  )

  var urlencoded = new URLSearchParams()
  urlencoded.append('REQUEST', 'GetFeature')
  urlencoded.append('VERSION', '1.1')
  urlencoded.append('typeName', layerName)
  urlencoded.append('RESULTTYPE', 'hits')

  const decodedFilter = cqlFilter !== undefined ? decodeURIComponent(cqlFilter) : undefined

  // urlencoded.append("cql_filter", cqlFilter);
  if (featureID !== undefined) {
    urlencoded.append('featureID', featureID)
  } else if (decodedFilter !== undefined) {
    urlencoded.append('cql_filter', decodedFilter)
  } else if ((featureID === undefined) & (decodedFilter === undefined)) {
  }

  var requestOptions = {
    method: 'POST',
    headers: myHeaders,
    body: urlencoded,
    redirect: 'follow'
  }

  getObjectFromPost(requestOptions, serverUrl, (result) => {
    console.log('result', result)
    callback(result['wfs:FeatureCollection']['$'].numberOfFeatures)
  })
}

export function getObjectFromPost(requestOptions, serverUrl, callback) {
  const wfsServerUrl = serverUrl + 'wfs'
  console.log('in getObjectFromPost ', wfsServerUrl)
  console.log('requestOptions', requestOptions)
  return (
    fetch(wfsServerUrl, requestOptions)
      // return fetch("https://docker.iesprit.sk/geoserver/wfs", requestOptions)
      .then((response) => response.text())
      .then((responseText) => {
        // CALLBACK WITH RESULT
        if (callback !== undefined) {
          parseString(responseText, function (err, result) {
            callback(result)
          })
        }
      })
      .catch((error) => {
        console.error(error)
      })
  )
}

// this.getJSON_lg(requestOptions, (result) => {
//   const geoJSON = new GeoJSON().readFeatures(result);
//   callback(geoJSON);
// });

export function zoomToFeature(feature, animate = true) {

  let geom = feature.getGeometry()
  let duration = animate ? 1000 : 0
  let minResolution = scaleToResolution(feature.minScale)
  minResolution = minResolution > 1 ? Math.ceil(minResolution) : 1
  if (geom.getType() === 'Point') {
    window.map
      .getView()
      .fit(geom, { duration: duration, minResolution: minResolution })
  } else if (geom.getType() === 'GeometryCollection') {
    window.map.getView().fit(geom.getGeometries()[0], {
      duration: duration,
      minResolution: minResolution
    })
  } else {
    window.map
      .getView()
      .fit(geom, { duration: duration, minResolution: minResolution })
  }
}

// THIS RETURNS THE ACTUAL REACT ELEMENT USING DOM ID
export function findReact(domId) {
  var dom = document.getElementById(domId)
  let key = Object.keys(dom).find((key) =>
    key.startsWith('__reactInternalInstance$')
  )
  let internalInstance = dom[key]
  if (internalInstance == null) return null

  if (internalInstance.return) {
    // react 16+
    return internalInstance._debugOwner
      ? internalInstance._debugOwner.stateNode
      : internalInstance.return.stateNode
  } else {
    // react <16
    return internalInstance._currentElement._owner._instance
  }
}

// URL FRIENDLY STRING ID
export function getUID() {
  return shortid.generate()
}

export function flashPoint(coords, zoom = 15, duration = 5000) {
  var marker = new Feature(new Point(coords))
  var vectorLayer = new VectorLayer({
    zIndex: 1000,
    source: new Vector({
      features: [marker]
    })
  })
  window.map.addLayer(vectorLayer)
  var mstyle = new Style({
    image: new CircleStyle({
      radius: 5,
      fill: new Fill({
        color: '#fff'
      }),
      stroke: new Stroke({
        color: 'blue',
        width: 2
      })
    }),
    zIndex: 100
  })
  marker.setStyle(mstyle)

  pulsate(vectorLayer, 'blue', marker, 5000, mstyle, () => {
    window.map.removeLayer(vectorLayer)
  })

  window.map.getView().animate({ center: coords, zoom: zoom })
}

function pulsate(vectorLayer, color, feature, duration, mstyle, callback) {
  var start = new Date().getTime()

  var key = vectorLayer.on('postrender', function (event) {
    var vectorContext = getVectorContext(event)
    var frameState = event.frameState
    var flashGeom = feature.getGeometry().clone()
    var elapsed = frameState.time - start
    var elapsedRatio = elapsed / duration
    var radius = easeOut(elapsedRatio) * 35 + 5
    var opacity = easeOut(1 - elapsedRatio)
    var fillOpacity = easeOut(0.5 - elapsedRatio)

    vectorContext.setStyle(
      new Style({
        image: new CircleStyle({
          radius: radius,
          snapToPixel: false,
          fill: new Fill({
            color: 'rgba(119, 170, 203, ' + fillOpacity + ')'
          }),
          stroke: new Stroke({
            color: 'rgba(119, 170, 203, ' + opacity + ')',
            width: 2 + opacity
          })
        })
      })
    )

    vectorContext.drawGeometry(flashGeom)

    // Draw the marker (again)
    vectorContext.setStyle(mstyle)
    vectorContext.drawGeometry(feature.getGeometry())

    if (elapsed > duration) {
      unByKey(key)
      //pulsate(color, feature, duration); // recursive function
      callback()
    }

    window.map.render()
  })

  // var key = window.map.on("postrender", function(event) {
  //   console.log(event);
  //   //var vectorContext = getVectorContext(event);
  //   if (event.vectorContext === undefined) return;
  //   var vectorContext = event.vectorContext;
  //   var frameState = event.frameState;
  //   var flashGeom = feature.getGeometry().clone();
  //   var elapsed = frameState.time - start;
  //   var elapsedRatio = elapsed / duration;
  //   var radius = easeOut(elapsedRatio) * 35 + 5;
  //   var opacity = easeOut(1 - elapsedRatio);
  //   var fillOpacity = easeOut(0.5 - elapsedRatio);

  //   vectorContext.setStyle(
  //     new Style({
  //       image: new CircleStyle({
  //         radius: radius,
  //         snapToPixel: false,
  //         fill: new Fill({
  //           color: "rgba(119, 170, 203, " + fillOpacity + ")"
  //         }),
  //         stroke: new Stroke({
  //           color: "rgba(119, 170, 203, " + opacity + ")",
  //           width: 2 + opacity
  //         })
  //       })
  //     })
  //   );

  //   vectorContext.drawGeometry(flashGeom);

  //   // Draw the marker (again)
  //   vectorContext.setStyle(mstyle);
  //   vectorContext.drawGeometry(feature.getGeometry());

  //   if (elapsed > duration) {
  //     unByKey(key);
  //     //pulsate(color, feature, duration); // recursive function
  //     callback();
  //   }

  //   window.map.render();
  // });
}

export function centerMap(coords, zoom) {
  var extent = window.map.getView().calculateExtent()
  console.log(extent)
  var xMin = extent[0]
  var xMax = extent[2]
  var total = (Math.abs(xMin) - Math.abs(xMax)) * 0.04
  var newCoords = [coords[0] - total, coords[1]]
  //var newExtent = [extent[0], extent[1], extent[2], total];

  window.map.setView(
    new ol.View({
      center: newCoords,
      //extent: newExtent,
      zoom: 13
    })
  )
}

export function formatTitleCase(str, maxLength = undefined) {
  //replace title case with space
  //replace underscore with space
  let formattedTitle = toTitleCase(
    str
      .split(/(?=[A-Z]{1}[a-z]+)|(?=[_ .])/)
      .join(' ')
      .replace(/[_.]/gm, '')
      .toLowerCase()
  )
  if (maxLength && maxLength < formattedTitle.length)
    formattedTitle = formattedTitle.substring(0, maxLength) + '...'
  return formattedTitle
}

export function toTitleCase(str) {
  return str.replace(/\w\S*/g, function (txt) {
    return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase()
  })
}

// OL BUG
// WORKAROUND - OL BUG -- https://github.com/openlayers/openlayers/issues/6948#issuecomment-374915823
// OL BUG
// export function convertMouseUpToClick(e) {
//   const evt = new CustomEvent("click", { bubbles: true });
//   evt.pageY = e.pageY;
//   evt.pageX = e.pageX;
//   evt.stopPropagation = () => {};
//   e.target.dispatchEvent(evt);
// }

// GET FEATURE FROM GEOJSON
export function getFeatureFromGeoJSON(geoJSON) {
  return new GeoJSON().readFeature(geoJSON)
}

export function getFeaturesFromGeoJSON(geoJSON) {
  return new GeoJSON().readFeatures(geoJSON)
}

// SEE EXAMPLE VALUES FROM HERE:  https://openlayers.org/en/latest/examples/vector-labels.html
// export function createTextStyle(
//   feature,
//   fieldName = 'name',
//   maxScale = 100000000,
//   align = 'center',
//   baseline = 'middle',
//   size = '10px',
//   offsetX = 0,
//   offsetY = 0,
//   weight = 'normal',
//   placement = 'point',
//   maxAngleDegrees = 359,
//   overflow = false,
//   rotation = 0,
//   font = 'arial',
//   fillColor = 'black',
//   outlineColor = 'white',
//   outlineWidth = 5
// ) {
//   //console.log(align)
//   offsetX = parseInt(offsetX, 10)
//   offsetY = parseInt(offsetY, 10)
//   maxAngleDegrees = parseFloat(maxAngleDegrees * 0.0174533)
//   rotation = parseFloat(rotation * 0.0174533)
//   var fullFont = weight + ' ' + size + ' ' + font
//   outlineWidth = parseInt(outlineWidth, 10)

//   var texts = new TextStyle({
//     textAlign: align,
//     textBaseline: baseline,
//     font: fullFont,
//     text: _getText(feature, fieldName, maxScale),
//     fill: new Fill({ color: fillColor }),
//     stroke: new Stroke({ color: outlineColor, width: outlineWidth }),
//     offsetX: offsetX,
//     offsetY: offsetY,
//     placement: placement,
//     maxAngle: maxAngleDegrees,
//     overflow: overflow,
//     rotation: rotation
//   })

//   //console.log(texts)
//   return texts
// }
export function createTextStyle(
  feature,
  fieldName = 'name',
  maxScale = 100000000,
  align = 'center',
  baseline = 'middle',
  size = '10px',
  offsetX = 0,
  offsetY = 0,
  weight = 'normal',
  placement = 'point',
  maxAngleDegrees = 359,
  overflow = false,
  rotation = 0,
  font = 'arial',
  fillColor = 'black',
  outlineColor = 'white',
  outlineWidth = 5
) {
  offsetX = parseInt(offsetX, 10);
  offsetY = parseInt(offsetY, 10);
  maxAngleDegrees = parseFloat(maxAngleDegrees * 0.0174533);
  rotation = parseFloat(rotation * 0.0174533);
  const fullFont = `${weight} ${size} ${font}`;
  outlineWidth = parseInt(outlineWidth, 10);

  const texts = new TextStyle({
    textAlign: align,
    textBaseline: baseline,
    font: fullFont,
    text: _getText(feature, fieldName, maxScale),
    fill: new Fill({ color: fillColor }),
    stroke: new Stroke({ color: outlineColor, width: outlineWidth }), // Nastavenie outline ako "pozadia"
    offsetX: offsetX,
    offsetY: offsetY,
    placement: placement,
    maxAngle: maxAngleDegrees,
    overflow: overflow,
    rotation: rotation
  });

  return texts;
}



function _getText(
  feature,
  fieldName = 'name',
  maxScale,
  type = 'normal',
  placement = 'point'
) {
  var text = feature.get(fieldName)
  if (getMapScale() > maxScale) {
    text = ''
  } else if (type === 'hide') {
    text = ''
  } else if (type === 'shorten') {
    text = text.trunc(12)
  } else if (type === 'wrap' && (!placement || placement.value !== 'line')) {
    text = stringDivider(text, 16, '\n')
  }

  return text
}

// https://stackoverflow.com/questions/14484787/wrap-text-in-javascript
export function stringDivider(str, width, spaceReplacer) {
  if (str.length > width) {
    var p = width
    while (p > 0 && str[p] !== ' ' && str[p] !== '-') {
      p--
    }
    if (p > 0) {
      var left
      if (str.substring(p, p + 1) === '-') {
        left = str.substring(0, p + 1)
      } else {
        left = str.substring(0, p)
      }
      var right = str.substring(p + 1)
      return left + spaceReplacer + stringDivider(right, width, spaceReplacer)
    }
  }
  return str
}

export function saveToStorage(storageKey, item) {
  try {
    window.localStorage.setItem(storageKey, JSON.stringify(item))
  } catch (e) {
    cleanupStorage()
  }
}
export function safeStringify(obj, replacer = null, space = 2) {
  const seen = new WeakSet();
  return JSON.stringify(obj, (key, value) => {
    if (typeof value === "object" && value !== null) {
      if (seen.has(value)) {
        return "[Circular]";
      }
      seen.add(value);
    }
    return value;
  }, space);
}

export function cleanupStorage() {
  const keys = ['searchHistory']
  keys.forEach((key) => {
    let localStore = JSON.parse(window.localStorage.getItem(key))
    window.localStorage.removeItem(key)
    if (key === 'searchHistory') {
      if (localStore.length > 0) {
        let cleanedSearchHistory = []
        localStore.forEach((item) => {
          delete item['geojson']
          cleanedSearchHistory.push(item)
        })
        localStore = JSON.stringify(cleanedSearchHistory)
      }
    }
    window.localStorage.setItem(key, localStore)
  })
}

export function appendToStorage(storageKey, item, limit = undefined) {
  let items = getItemsFromStorage(storageKey)
  if (items === undefined) items = []
  console.log('appendToStorage', storageKey, item, items)

  item.dateAdded = new Date().toLocaleString()
  items.unshift(item)
  if (limit !== undefined) {
    if (items.length > limit) items.pop()
  }
  try {
    window.localStorage.setItem(storageKey, JSON.stringify(items))
  } catch (e) {
    cleanupStorage()
  }
}

export function getItemsFromStorage(key) {
  const storage = window.localStorage.getItem(key)
  if (storage === null) return undefined

  const data = JSON.parse(storage)
  return data
}

export function postJSON(url, data = {}, callback) {
  // Default options are marked with *
  console.log('postJSON', url, data)
  return fetch(url, {
    method: 'POST', // *GET, POST, PUT, DELETE, etc.
    mode: 'cors', // no-cors, cors, *same-origin
    cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
    credentials: 'same-origin', // include, *same-origin, omit
    headers: {
      'Content-Type': 'application/json'
      //'Content-Type': 'application/x-www-form-urlencoded',
    },
    redirect: 'follow', // manual, *follow, error
    referrer: 'no-referrer', // no-referrer, *client
    body: JSON.stringify(data) // body data type must match "Content-Type" header
  })
    .then((res) => {
      return res.json()
    })
    .then((json) => {
      callback(json)
    })
}
export function postUrl(url, callback) {
  // Default options are marked with *
  return fetch(url, {
    method: 'POST', // *GET, POST, PUT, DELETE, etc.
    mode: 'cors', // no-cors, cors, *same-origin
    cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
    credentials: 'same-origin', // include, *same-origin, omit
    redirect: 'follow', // manual, *follow, error
    referrer: 'no-referrer' // no-referrer, *client
  }).then((res) => {
    callback(res)
  })
}
export function featureToGeoJson(feature) {
  return new GeoJSON({
    dataProjection: 'EPSG:5514',
    featureProjection: 'EPSG:5514'
  }).writeFeature(feature, {
    dataProjection: 'EPSG:5514',
    featureProjection: 'EPSG:5514'
  })
}

export function getWKTFeature(wktString) {
  if (wktString === undefined) return

  // READ WKT
  var wkt = new WKT()
  var feature = wkt.readFeature(wktString, {
    dataProjection: 'EPSG:5544',
    featureProjection: 'EPSG:5514'
  })
  return feature
}

export function getWKTStringFromFeature(feature) {
  console.log('getWKTStringFromFeature', feature)
  var wkt = new WKT()
  //   console.log("XYZ layout", feature.geometryChangeKey_.target.layout);
  //     if ((feature.geometryChangeKey_.target.layout === "XYZ")) {
  //       var coordinates = feature.getGeometry().flatCoordinates;
  //       var newCoordinates = coordinates.filter(function (_, index) {
  //         return index % 3 !== 2;
  //       });
  //       feature.geometryChangeKey_.target.flatCoordinates = newCoordinates;
  //       feature.geometryChangeKey_.target.layout = "XY";
  //     }
  const wktString = wkt.writeFeature(feature)
  return wktString
}

export function formatReplace(fmt, ...args) {
  if (!fmt.match(/^(?:(?:(?:[^{}]|(?:\{\{)|(?:\}\}))+)|(?:\{[0-9]+\}))+$/)) {
    throw new Error('invalid format string.')
  }
  return fmt.replace(
    /((?:[^{}]|(?:\{\{)|(?:\}\}))+)|(?:\{([0-9]+)\})/g,
    (m, str, index) => {
      if (str) {
        return str.replace(/(?:{{)|(?:}})/g, (m) => m[0])
      } else {
        if (index >= args.length) {
          throw new Error('argument index is out of range in format')
        }
        return args[index]
      }
    }
  )
}

export function toLatLongFromWebMercator(coords) {
  return transform(coords, 'EPSG:3857', 'EPSG:4326')
}

export function toWebMercatorFromLatLong(coords) {
  return fromLonLat(coords)
  //return transform(coords, "EPSG:4326", "EPSG:3857");
}

export function getGeoJSONFromGeometry(geometry) {
  const parser = new GeoJSON()
  return parser.writeGeometry(geometry)
}

export function getGeometryFromGeoJSON(geometry) {
  const parser = new GeoJSON()
  return parser.readGeometry(geometry)
}

//Generate Feature Reports for a Polygon (reproting area)
export function generateReport(
  feature,
  report,
  buffer = 0,
  callback = undefined
) {
  const url = mainConfig.reportsUrl + report
  let geom = feature.getGeometry()
  //const utmNad83Geometry = geom.transform("EPSG:3857", _nad83Proj);
  const geoJSON = getGeoJSONFromGeometry(geom)
  const obj = { geoJSON: geoJSON, srid: '3857', buffer: buffer }
  return fetch(url, {
    method: 'POST', // *GET, POST, PUT, DELETE, etc.
    mode: 'cors', // no-cors, cors, *same-origin
    cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
    credentials: 'same-origin', // include, *same-origin, omit
    headers: {
      'Content-Type': 'application/json'
      //'Content-Type': 'application/x-www-form-urlencoded',
    },
    redirect: 'follow', // manual, *follow, error
    referrer: 'no-referrer', // no-referrer, *client
    body: JSON.stringify(obj), // body data type must match "Content-Type" header
    xhrFields: {
      responseType: 'blob'
    }
  })
    .then((response) => response.blob())
    .then((blob) => {
      var d = new Date(Date.now())
      download(
        blob,
        'Report ' +
          d.toISOString().slice(0, 10).replace(/-/g, '') +
          d.toTimeString().slice(0, 8).replace(/:/g, '') +
          '.xlsx',
        { isBlob: true }
      )
      callback(true)
    })
}

export function download(url, filename = undefined, options = undefined) {
  if (!options) options = {}
  try {
    if (options.isBlob) {
      url = window.URL.createObjectURL(url)
    }
    var link = document.createElement('a')
    link.setAttribute('href', url)
    link.setAttribute('target', '_blank')
    link.setAttribute('rel', 'noopener noreferrer')
    if (!isLoaded('apptrack-theme')) link.setAttribute('download', filename)
    document.body.appendChild(link) // Required for FF
    link.click()
    document.body.removeChild(link) //afterwards we remove the element again
  } catch (e) {
    window.open(url, `_blank`)
  }
}

export function previewReport(feature, report, buffer = 0, callback) {
  const url = mainConfig.reportsUrl + report
  let geom = feature.getGeometry()
  //const utmNad83Geometry = geom.transform("EPSG:3857", _nad83Proj);
  const geoJSON = getGeoJSONFromGeometry(geom)
  const obj = { geoJSON: geoJSON, srid: '3857', buffer: buffer }
  return fetch(url, {
    method: 'POST', // *GET, POST, PUT, DELETE, etc.
    mode: 'cors', // no-cors, cors, *same-origin
    cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
    credentials: 'same-origin', // include, *same-origin, omit
    headers: {
      'Content-Type': 'application/json'
      //'Content-Type': 'application/x-www-form-urlencoded',
    },
    redirect: 'follow', // manual, *follow, error
    referrer: 'no-referrer', // no-referrer, *client
    body: JSON.stringify(obj) // body data type must match "Content-Type" header
  })
    .then((res) => {
      return res.json()
    })
    .then((json) => {
      callback(json)
    })
}

export function bufferGeometry(geometry, distanceMeters, callback) {
  waitForLoad('settings', Date.now(), 30, () => {
    const url = window.config.apiUrl + 'postBufferGeometry/'

    // PROJECT TO UTM FOR ACCURACY
    const utmNad83Geometry = geometry.transform('EPSG:3857', _nad83Proj)
    const geoJSON = getGeoJSONFromGeometry(utmNad83Geometry)
    const obj = { geoJSON: geoJSON, distance: distanceMeters, srid: '26917' }

    postJSON(url, obj, (result) => {
      // REPROJECT BACK TO WEB MERCATOR
      const olGeoBuffer = getGeometryFromGeoJSON(result.geojson)
      const utmNad83GeometryBuffer = olGeoBuffer.transform(
        'EPSG:26917',
        'EPSG:3857'
      )

      callback(utmNad83GeometryBuffer)
    })
  })
}

export function disableKeyboardEvents(disable) {
  if (window.map !== undefined && window.map !== null) {
    window.map.getInteractions().forEach(function (interaction) {
      if (
        interaction instanceof KeyboardPan ||
        interaction instanceof KeyboardZoom
      ) {
        interaction.setActive(!disable)
      }
    })
  }
}

export function getGeometryCenter(geometry, callback) {
  waitForLoad('settings', Date.now(), 30, () => {
    const url = window.config.apiUrl + 'postGetGeometryCenter/'
    const geoJSON = getGeoJSONFromGeometry(geometry)
    const obj = { geoJSON: geoJSON, srid: '3857' }

    postJSON(url, obj, (result) => {
      const olGeo = getGeometryFromGeoJSON(result.geojson)
      callback(olGeo)
    })
  })
}
export async function asyncForEach(array, callback) {
  for (let index = 0; index < array.length; index++) {
    await callback(array[index], index, array)
  }
}

export function replaceAllInString(str, find, replace) {
  return str.replace(new RegExp(_escapeRegExp(find), 'g'), replace)
}
function _escapeRegExp(str) {
  // eslint-disable-next-line
  return str.replace(/([.*+?^=!:${}()|\[\]\/\\])/g, '\\$1')
}

export function showFeaturePopup(coord, feature) {
  if (window.popupOn === false) return

  if (feature.geometry === null) {
    console.log('Feature geometry is null')
    const defaultLayerName = feature.layerName || 'Vrstva'
    window.popup.show(
      coord,
      <>
        <FeaturePopup
          feature={feature}
          class="sc-live-layer-popup-content"
        />
      </>,
      defaultLayerName
    )
  } else {
    const tabName = feature.layer.tocDisplayName || feature.tabName
    console.log('tabname', tabName)

    window.popup.show(
      coord,
      <>
        <FeaturePopup
          feature={feature}
          class="sc-live-layer-popup-content"
        />
      </>,
      tabName
    )
  }
}

export function showMyFeaturePopup(coord, feature) {

  if (window.popupOn === false) {
    return
  }

  let uniqueFeatures = []
  const addedLayerNames = new Set()  // Set na sledovanie pridaných layerName
  const popupExcludedLayers = mainConfig.popupExcludedLayers

  if (feature.length > 1) {
    feature.forEach((feat, index) => {

      // Získaj `layerName` a `layerSource` z rôznych miest
      const layerName = feat.layerName || feat.layer?.values_?.name
      let layerSource = feat.layerSource || feat.layer?.values_?.source || ''

      // Ak je `layerSource` objektom, nastavíme ho na undefined
      if (typeof layerSource === 'object') {
        layerSource = undefined
      }

      let tabname = ''
      tabname =
        feat.layer?.tocDisplayName ||
        feat.tabName ||
        feat.layer?.values_.displayName ||
        layerName

      if (feat.layerSource === 'searchComponent') {
        tabname = feat.tabName
      }

      // Kontrola, či je `id_` a `className` definované
      if (feat.id_ === undefined || tabname === undefined) {
        console.log(`Feature #${index + 1} has undefined id_ or className. Skipping.<<<<<<<<<`);
        return;
      }

      if (tabname && !popupExcludedLayers.includes(tabname)) {

        // Ak layerName už bol pridaný a `layerSource` obsahuje 'checkbox', ignorujeme túto vrstvu
        if (addedLayerNames.has(layerName)) {
          if (layerSource && layerSource.includes('checkbox')) {
            return
          } else {
            // Pridanie podrobných výpisov pre kontrolu hodnôt
            uniqueFeatures = uniqueFeatures.filter(f => {
              const fLayerName = f.layerName || f.layer?.values_?.name
              let fLayerSource = f.layerSource || f.layer?.values_?.source || ''
              
              if (typeof fLayerSource === 'object') {
                fLayerSource = undefined
              }
              return (fLayerName !== layerName || !(fLayerSource && fLayerSource.includes('checkbox')))
            })
          }
        }

        // Pridanie layerName do Setu a pridanie feature do uniqueFeatures
        addedLayerNames.add(layerName)
        uniqueFeatures.push(feat)
      } else {
        console.log(`Feature #${index + 1} is excluded or has no valid tabname. Skipping.`)
      }
    })
  } else {
      // Kontrola pre single feature
      if (feature[0]?.id_ !== undefined) {
        uniqueFeatures = feature;
      } else {
        console.log('Single feature has undefined id_ or className. Skipping.');
        return;
      }
  }


  if (uniqueFeatures.length > 1) {
    const newCoord1 = [coord[0], coord[1] + 0.000000001]

    window.popup.show(
      newCoord1,
      <>
        <FeaturePopup
          feature={uniqueFeatures}
          class="sc-live-layer-popup-content"
        />
      </>,
      'Informácie o vrstvách'
    )
  } else if (uniqueFeatures.length === 1) {
    const feat = uniqueFeatures[0]

    window.emitter.emit('removeRenderedFeature', 'allHighlights')
    window.emitter.emit('highlightOnMap', feat)
    highlightRow(feat)

    const tabName =
      feat.layer?.tocDisplayName ||
      feat.tabName ||
      feat.layer?.values_.displayName
    const newCoord = [coord[0], coord[1] + 0.000000001]

    if (popupExcludedLayers.includes(tabName)) {
      return
    }

    window.popup.show(
      newCoord,
      <>
        <FeaturePopup
          feature={feat}
          class="sc-live-layer-popup-content"
        />
      </>,
      tabName
    )
  } else {
  }
}

export function removeURLParameter(url, parameter) {
  //prefer to use l.search if you have a location/link object
  var urlparts = url.split('?')
  if (urlparts.length >= 2) {
    var prefix = encodeURIComponent(parameter) + '='
    var pars = urlparts[1].split(/[&;]/g)

    //reverse iteration as may be destructive
    for (var i = pars.length; i-- > 0; ) {
      //idiom for string.startsWith
      if (pars[i].lastIndexOf(prefix, 0) !== -1) {
        pars.splice(i, 1)
      }
    }

    return urlparts[0] + (pars.length > 0 ? '?' + pars.join('&') : '')
  }
  return url
}

export function FeaturePopup(props) {
  const [urlList, setUrlList] = useState({});
  const KN_LAYER_NAMES = mainConfig.knLayerNames;

  const features = useMemo(
    () => (Array.isArray(props.feature) ? props.feature : [props.feature]),
    [props.feature]
  );

  useEffect(() => {
    const fetchUrls = async () => {
      const newUrlList = {};

      for (let feature of features) {
        const feat = feature.layer || feature;

        if (!feat?.values_) continue;

        const isKNLayer = KN_LAYER_NAMES.includes(feat.values_.name);
        const isCKN =
          feat.values_.name === '15,14,13,12,11,10,9,8,7,6,5,4,3,2,1' ||
          feat.values_.name === '15,14,13,12,11,10,9,8,7,6,5,4,3,2,1,';
        const isEKN =
          feat.values_.name === '0,1,2,3,4,5' ||
          feat.values_.name === '0,1,2,3,4,5,';

        if (isKNLayer) {
          try {
            let parcelNumber;
            let registerLetter;

            if (isCKN) {
              parcelNumber = feature.values_['ČísloparcelyregistraC'];
              registerLetter = 'C';
            } else if (isEKN) {
              parcelNumber = feature.values_['ČísloparcelyregistraE'];
              registerLetter = 'E';
            }

            if (parcelNumber) {
              parcelNumber = parcelNumber.includes('/')
                ? parcelNumber.replace(/\//g, '---')
                : parcelNumber;
            }

            const cisloListuVlastnictva =
              feature.values_['Číslolistuvlastníctva'];
            const kodKatastralnehoUzemia =
              feature.values_['Kódkatastrálnehoúzemia'];

            if (
              !cisloListuVlastnictva ||
              cisloListuVlastnictva === 'Null' ||
              !kodKatastralnehoUzemia ||
              !registerLetter ||
              !parcelNumber
            ) {
              console.log('Invalid input parameters');
              continue;
            }

            const response = await fetch(
              `${window.config.apiUrlEsprit}/kataster/lvc/${cisloListuVlastnictva}/${kodKatastralnehoUzemia}/${registerLetter}/${parcelNumber}`
            );

            if (!response.ok) {
              throw new Error(`HTTP error! status: ${response.status}`);
            }

            const result = await response.json();
            const apiUrlEsprit = mainConfig.apiUrlEsprit;

            if (!result.pdf_u || !result.pdf_c) {
              throw new Error('Invalid response data');
            }

            newUrlList[feature.ol_uid] = {
              fullListUrl: `${apiUrlEsprit}kataster/pdf/${result.pdf_u}`,
              partialListUrl: `${apiUrlEsprit}kataster/pdf/${result.pdf_c}`
            };
          } catch (error) {
            console.error('Error fetching data:', error);
          }
        }
      }

      // Aktualizujte stav iba v prípade, že existujú nové údaje na pridanie
      if (Object.keys(newUrlList).length > 0) {
        setUrlList((prevUrlList) => {
          return { ...prevUrlList, ...newUrlList };
        });
      }
    };

    if (features.length > 0) {
      fetchUrls();
    }
  }, [features, KN_LAYER_NAMES]);

  return (
    <div className={props.class}>
      {features.map((feature, index) => {
        const feat = feature.layer || feature;

        if (!feat.values_) return null;

        const isKNLayer = KN_LAYER_NAMES.includes(feat.values_.name);
        const tabName =
          feat?.tocDisplayName ||
          feature.tabName ||
          feat?.values_?.displayName ||
          feature.layerName;

        const featureId = feature.id_;
        let featureClassName = '';

        if (feature.layerSource === 'kn') {
          featureClassName = feature.layerSource;
        } else if (feature?.id_?.includes('-kn_')) {
          featureClassName = 'kn';
        } else if (isKNLayer) {
          featureClassName = 'kn_wms';
        } else {
          featureClassName =
            feature.layerName || featureId?.substring(0, featureId.indexOf('.'));
        }

        const featureClassesListFromConfig = Object.keys(
          mainConfig.layerAttributesForPopup
        );
        const popUpDefinedInConfig =
          featureClassesListFromConfig.includes(featureClassName);

        const fromPrevResult = feature.layerSource === 'prevRes';
        let isFeatureInItems = false;
        const itemsList = window.items.map((item) =>
          item.alias ? item.alias : item.name
        );
        if (itemsList.length > 0) {
          isFeatureInItems = itemsList.includes(tabName);
        }

        if (!popUpDefinedInConfig) {
          // Filter pre ignorovanie určitých kľúčov
          const filterKeys = [
            '[_].*',
            'id',
            'geometry',
            'geom',
            'extent_geom',
            '.*gid.*',
            'globalid',
            'objectid.*',
            'shape.*',
            'displayfieldname',
            'displayfieldvalue',
            'geostasis[.].*',
            '.*fid.*',
            'pzuser',
            'pztime',
            'orig_geom_name',
            '',
            'PDF',
            'pdf2',
            'PDF2',
            'rawgeometry_type',
            'rawgeometry_coordinates'
          ];
        
          const filterByKeyName = (keyName) => {
            return (
              filterKeys.filter((filterItem) => {
                let returnValue = false;
                var regexTest = new RegExp(`^${filterItem}$`);
                returnValue = regexTest.test(keyName);
                return returnValue;
              }).length === 0
            );
          };
        
          // Získanie vlastností feature
          const featureProps = feature.getProperties();
          let keys = Object.keys(featureProps);
        
          // Filtrovanie kľúčov na základe filterKeys
          keys = keys.filter((key) => {
            const keyName = key.toLowerCase();
            let val = featureProps[key];
            if (val === undefined) {
              try {
                val = feature.get(key);
              } catch (e) {
                console.log(e.message);
              }
            }
            if (val === null) val = '';
            if (typeof val === 'object') return false; // Vylúčenie objektov
            return filterByKeyName(keyName);
          });
        
          return (
            <div key={index} style={{ marginBottom: '10px', marginRight: '8px' }}>
              {features.length > 1 && (
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    height: '35px'
                  }}
                >
                  <h3 className="popup-subtitle">{tabName}</h3>
                </div>
              )}
              <div style={{ marginBottom: '10px' }}>
                {keys.map((key, i) => {
                  let val = featureProps[key] || feature[key];
                  if (val === undefined) {
                    try {
                      val = feature.get(key);
                    } catch (e) {
                      console.log(e.message);
                    }
                  }
                  if (typeof val === 'boolean') {
                    val = val ? 'áno' : 'nie';
                  } else if (
                    val === null ||
                    val === undefined ||
                    val === 'Null'
                  ) {
                    val = '-';
                  }
                  return (
                    <InfoRow
                      key={i}
                      value={String(val)}
                      label={formatTitleCase(key)}
                    />
                  );
                })}
              </div>
              {isFeatureInItems && !fromPrevResult && (
                <button
                  className="sc-button sc-search-popup-content-button btn-base btn-primary"
                  onClick={() => highlightInTable(feature)}
                  style={{ cursor: 'pointer' }}
                >
                  Zobraziť v atribútovej tabuľke
                </button>
              )}
              {feature.values_?.oid !== undefined && (
                <button
                  className="sc-button sc-search-popup-content-button btn-base btn-primary"
                  onClick={() => openPageByOID(feature.values_?.oid)}
                  style={{ cursor: 'pointer' }}
                >
                  Zobraziť prílohy
                </button>
              )}
              {!isKNLayer && !window.config.hideKNfromPopup && (
                <button
                  className="sc-button sc-search-popup-content-button btn-base btn-primary"
                  onClick={() => openReport(feature)}
                  id="large-popup-button"
                  style={{
                    cursor: 'pointer',
                    marginBottom: '4px',
                    fontSize: '3rem !important'
                  }}
                >
                  Parcely
                </button>
              )}
            </div>
          );
        }
         else {
          const attributes =
            mainConfig.layerAttributesForPopup[featureClassName];
          const featureProps = feature.getProperties();
          const featurekeys = Object.keys(featureProps);

          let filteredKeys = attributes.filter(
            (row) =>
              featurekeys.includes(row.field) &&
              !row.field.includes('pdf') &&
              !row.field.includes('pdf2')
          );

          // Získanie URL pre PDF súbory z urlList
          const { fullListUrl, partialListUrl } = urlList[feature.ol_uid] || {};

          return (
            <div key={index} style={{ marginBottom: '10px', marginRight: '8px' }}>
              {(features.length > 1 || isKNLayer) && (
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    height: '35px'
                  }}
                >
                  <h3 className="popup-subtitle">
                    {features.length > 1 ? tabName : isKNLayer ? '' : null}
                  </h3>
                  {isKNLayer && (
                    <div style={{ fontSize: '1.5rem' }}>
                      {fullListUrl && (
                        <a
                          href={fullListUrl}
                          target="_blank"
                          rel="noopener noreferrer"
                          title="Úplný list vlastníctva"
                        >
                          <Icon name="file pdf" />
                        </a>
                      )}
                      {partialListUrl && (
                        <a
                          href={partialListUrl}
                          target="_blank"
                          rel="noopener noreferrer"
                          title="Čiastočný list vlastníctva"
                        >
                          <Icon name="file pdf outline" />
                        </a>
                      )}
                    </div>
                  )}
                </div>
              )}
              <div style={{ marginBottom: '10px' }}>
                {filteredKeys.map((obj, i) => {
                  let field = obj.field;
                  let alias = obj.alias;
                  let val = feature.get(field);

                  if (typeof val === 'boolean') {
                    val = val ? 'áno' : 'nie';
                  } else if (
                    val === null ||
                    val === undefined ||
                    val === 'Null'
                  ) {
                    val = '-';
                  }

                  return (
                    <InfoRow
                      key={i}
                      value={String(val)}
                      label={`${alias}`}
                      field={`${field}`}
                    />
                  );
                })}
              </div>
              {isFeatureInItems && !fromPrevResult && (
                <button
                  className="sc-button sc-search-popup-content-button btn-base btn-primary"
                  onClick={() => highlightInTable(feature)}
                  style={{ cursor: 'pointer' }}
                >
                  Zobraziť v atribútovej tabuľke
                </button>
              )}
              {feature.values_?.oid !== undefined && !window.config.hideKNfromPopup && (
                <button
                  className="sc-button sc-search-popup-content-button btn-base btn-primary"
                  onClick={() => openPageByOID(feature.values_?.oid)}
                  style={{ cursor: 'pointer' }}
                >
                  Zobraziť prílohy
                </button>
              )}
              {!isKNLayer && !window.config.hideKNfromPopup && (
                <button
                  className="sc-button sc-search-popup-content-button btn-base btn-primary"
                  onClick={() => openReport(feature)}
                  id="large-popup-button"
                  style={{
                    cursor: 'pointer',
                    marginBottom: '4px',
                    fontSize: '3rem !important'
                  }}
                >
                  Parcely
                </button>
              )}
            </div>
          );
        }
      })}
    </div>
  );
}



export function openPageByOID(oid) {
  const baseUrl = window.config.lomtecUrl
  //const fullUrl = baseUrl.replace("hereIsID", oid);
  const fullUrl = baseUrl + oid
  console.log('fullUrl', fullUrl)
  window.open(fullUrl, '_blank')
}

async function fetchGeometryFromGeoserver(fid, layerName) {
  try {
    if (!fid) {
      throw new Error('Missing fid for Geoserver request');
    }

    const geoserverBaseUrl = window.config.geoserverUrl; // Base URL pre váš Geoserver
    const geoserverUrl = `${geoserverBaseUrl}/wfs`;

    // Vytvorenie CQL filtra a URL požiadavky
    const cqlFilter = `fid='${fid}'`;
    const geoserverRequestUrl = `${geoserverUrl}?SERVICE=WFS&VERSION=1.1.0&REQUEST=GetFeature&typeName=${layerName}&CQL_FILTER=${encodeURIComponent(cqlFilter)}&outputFormat=application/json`;

    // Odoslanie požiadavky na Geoserver
    const geoserverResponse = await fetch(geoserverRequestUrl);
    if (!geoserverResponse.ok) {
      const errorText = await geoserverResponse.text();
      throw new Error(`Failed to fetch geometry from Geoserver: ${errorText}`);
    }

    const geoserverData = await geoserverResponse.json();
    if (!geoserverData.features || geoserverData.features.length === 0) {
      throw new Error('No geometry found for the given fid in Geoserver');
    }

    // Extrahovanie geometrie
    const geometry = geoserverData.features[0]?.geometry;
    if (!geometry) {
      throw new Error('No valid geometry found in Geoserver response');
    }

    console.log('Geometry fetched from Geoserver:', geometry);
    return geometry;
  } catch (error) {
    console.error('Failed to fetch geometry from Geoserver:', error.message);
    return null; // Vrátime null, ak sa nepodarí získať geometriu
  }
}


export async function openReport(feature) {
  try {
    console.log('in openReport', feature);

    const layerName = feature.layer?.values_?.name || feature.layerName;
    const fid = feature.values_?.fid;

    // Skúsiť získať geometriu z Geoservera
    let geometry = await fetchGeometryFromGeoserver(fid, layerName);

    // Ak sa nepodarí získať geometriu z Geoservera, pokračovať s existujúcou logikou
    if (!geometry) {
      const geoJson = helpers.featureToGeoJson(feature);
      if (!geoJson) {
        throw new Error('Failed to convert feature to geoJson');
      }

      var jsonObj = JSON.parse(geoJson);
      geometry = jsonObj.geometry;

      if (geometry === null) {
        const inputCoords = feature.coords;
        const formattedCoords = {
          type: 'MultiPoint',
          coordinates: [inputCoords.map((coord) => parseFloat(coord.toFixed(4)))]
        };
        geometry = formattedCoords;
      }
    }

    const geometryString = JSON.stringify(geometry);
    window.emitter.emit('mapLoading');

    const baseUrl = window.config.apiUrlEsprit;
    const path = 'kataster/geom/parcels/webgis';
    const url = baseUrl + path;

    const requestBody = {
      geom: geometryString
    };
    console.log('requestBody', requestBody);

    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(requestBody)
    });

    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(`Network response was not ok: ${errorText}`);
    }

    const data_raw = await response.json();

    // Check if the data is an empty object
    if (Object.keys(data_raw).length === 0) {
      helpers.showMessage(
        'Upozornenie',
        'Vybraný objekt neobsahuje informácie o parcelách.',
        helpers.messageColors.red,
        5000
      );
      throw new Error('No data available for display');
    }

    const data = {
      c: data_raw.c, // Dátové pole pre parcely registra C
      e: data_raw.e, // Dátové pole pre parcely registra E
      layerName: layerName // Pridanie layerName do objektu data
    };

    window.emitter.emit('activateTab', 'reports');
    window.emitter.emit('activateReportContent', data);
    window.emitter.emit('mapLoaded');
  } catch (error) {
    console.error('There was a problem:', error.message);
    window.emitter.emit('mapLoaded');
  }
}

export function FeaturePopupWithoutGeometry(props) {
  console.log('in FeaturePopupWithoutGeometry', props)
  const tabName =
    props.feature.layer?.tocDisplayName ||
    props.feature.tabName ||
    props.feature.layer?.values_.displayName ||
    props.feature.layerName
  console.log('tabName', tabName)

  const fromPrevResult = props.feature.layerSource === 'prevRes' ? true : false

  let isFeatureInItems = false
  let itemsList = window.items.map((item) => {
    return item.alias ? item.alias : item.name
  })
  if (itemsList.length > 0) {
    isFeatureInItems = itemsList.includes(tabName) ? true : false
  }

  if (props.feature.id_ !== undefined) {
    const featureId = props.feature.id_
    const featureClassName =
      props.feature.layerName || featureId.substring(0, featureId.indexOf('.'))

    //chceck if Aliases for feature class are defined in config
    const featureClassesListFromCongif = Object.keys(
      mainConfig.layerAttributesForPopup
    )
    const popUpDefinedInConfig =
      featureClassesListFromCongif.includes(featureClassName)

    if (popUpDefinedInConfig === false) {
      console.log('popUpDefinedInConfig === false')
      return FeatureContent(props)
    } else {
      console.log('popUpDefinedInConfig === true')
      const attributes = mainConfig.layerAttributesForPopup[featureClassName]
      const featureProps = props.feature.getProperties()
      const featurekeys = Object.keys(featureProps)

      let filteredKeys = attributes.filter((row) =>
        featurekeys.includes(row.field)
      )
      return (
        <>
          <div className={props.class}>
            {filteredKeys.map((obj, i) => {
              let field = obj.field
              let alias = obj.alias
              let val = props.feature.get(field)

              return (
                <InfoRow
                  key={i}
                  value={String(val)}
                  label={`${alias}`}
                />
              )
            })}
            {(isFeatureInItems === true) & !fromPrevResult ? (
              <button
                className="sc-button sc-search-popup-content-button btn-base btn-primary"
                // onClick={() => highlightInTable(props)}
                style={{
                  cursor: 'pointer'
                }}
              >
                Zobraziť v atribútovej tabuľke
              </button>
            ) : null}
          </div>
        </>
      )
    }
  } else {
    console.log('props.feature.id_ === undefined')
  }
}

export function FeaturePopupLayerSelect({ feature, coord }) {
  console.log('in FeaturePopupLayerSelect', feature, coord)
  return (
    <div>
      <ul className="feature-popup-select">
        {feature.map((item) => (
          <li
            key={item.ol_uid}
            onClick={() => openLayerPopup(item, coord)}
            className="text-h1"
          >
            <div className="container">
              <FontAwesomeIcon
                className="faIcons faLayers-icon"
                icon={faLayerGroup}
                alt="polygon"
              />{' '}
              <div className="text">
                {item.tabName || item.layer?.values_.displayName}
              </div>
            </div>
          </li>
        ))}
      </ul>
    </div>
  )
}

export function openLayerPopup(feature, coord) {
  console.log('in openLayerPopup', feature, coord, feature.layerName)

  window.emitter.emit('removeRenderedFeature', 'allHighlights')
  window.emitter.emit('highlightOnMap', feature)
  highlightRow(feature)

  const tabName =
    feature.layer?.tocDisplayName ||
    feature.tabName ||
    feature.layer?.values_.displayName
  const newCoords = [coord[0], coord[1] + 0.000000001]

  window.popup.show(
    newCoords,
    <>
      <FeaturePopup
        feature={feature}
        class="sc-live-layer-popup-content"
      />
    </>,
    tabName
  )
}

export function FeatureContent(props) {
  //WILDCARD = .*
  //LITERAL STRING = [] EG: [_][.]
  //NOT STRING = (?!string) EG: geostasis[.](?!test).*
  const filterKeys = [
    '[_].*',
    'id',
    'geometry',
    'geom',
    'extent_geom',
    '.*gid.*',
    'globalid',
    'objectid.*',
    'shape.*',
    'displayfieldname',
    'displayfieldvalue',
    'geostasis[.].*',
    '.*fid.*',
    'pzuser',
    'pztime',
    'orig_geom_name',
    '',
    'PDF',
    'pdf2',
    'PDF2',
    'rawgeometry_type',
    'rawgeometry_coordinates'
  ]

  const tabName =
    props.feature.layer?.tocDisplayName ||
    props.feature.tabName ||
    props.feature.layer?.values_.displayName ||
    props.feature.layerName

  const fromPrevResult = props.feature.layerSource === 'prevRes' ? true : false

  //   const fromURI = props.feature.layerSource === "uri" ? true : false;
  let isFeatureInItems = false
  let itemsList = window.items.map((item) => {
    return item.alias ? item.alias : item.name
  })
  if (itemsList.length > 0) {
    isFeatureInItems = itemsList.includes(tabName) ? true : false
  }

  const featureProps = props.feature.getProperties()
  let keys = Object.keys(featureProps)

  const filterByKeyName = (keyName) => {
    return (
      filterKeys.filter((filterItem) => {
        let returnValue = false
        //returnValue = filterItem === keyName; //check for exact match
        //if (!returnValue){
        var regexTest = new RegExp(`^${filterItem}$`)
        returnValue = regexTest.test(keyName)
        //}
        return returnValue
      }).length === 0
    )
  }
  keys = keys.filter((key, i) => {
    // window.www = props.feature;
    const keyName = key.toLowerCase()
    window.props = featureProps
    let val = featureProps[key] // First, try to access the property directly
    // let val = props.feature[key]; // First, try to access the property directly
    if (val === undefined) {
      // If direct access fails (returns undefined)
      try {
        val = props.feature.get(key) // Try to call the 'get' method
      } catch (e) {
        console.log(e.message) // If 'get' is not a function, this will print an error message to the console
      }
    }
    if (val === null) val = ''
    if (typeof val === 'object') return false //EXCLUDE ALL OBJECT FIELDS
    return filterByKeyName(keyName)
  })

  return (
    <>
      <div className={props.class}>
        {keys.map((keyName, i) => {
          //   let val = props.feature.get(keyName);
          let val = featureProps[keyName] || props.feature[keyName]

          if (val === undefined) {
            // If direct access fails (returns undefined)
            try {
              val = props.feature.get(keyName) // Try to call the 'get' method
            } catch (e) {
              console.log(e.message) // If 'get' is not a function, this will print an error message to the console
            }
          }
          return (
            <InfoRow
              key={getUID()}
              value={val}
              label={formatTitleCase(keyName)}
            />
          )
        })}
        {/* {isFeatureInItems === true ? ( */}
        {(isFeatureInItems === true) & !fromPrevResult ? (
          <button
            className="sc-button sc-search-popup-content-button btn-base btn-primary"
            onClick={() => highlightInTable(props)}
            style={{
              cursor: 'pointer'
            }}
          >
            Zobraziť v atribútovej tabuľke
          </button>
        ) : null}
      </div>
    </>
  )
}

export function arrayContains(item, array) {
  return array.indexOf(item) > -1
}

export function allRowsWhite() {
  // vsetky riadky transparentne
  var tabRows_transparent = document.getElementsByClassName('tr'),
    index_t = tabRows_transparent.length
  while (index_t--) {
    tabRows_transparent[index_t].className = 'tr transparent-color'
  }
  // vsetky riadky biele
  var tabRows_white = document.getElementsByClassName('td'),
    index_w = tabRows_white.length
  while (index_w--) {
    tabRows_white[index_w].className = 'td white-color'
  }
}

export function selectRow(id) {
  console.log('in selectRow', id)
  var tabRow = document.getElementById(id).getElementsByClassName('td'),
    index_r = tabRow.length
  while (index_r--) {
    tabRow[index_r].className = 'td highlight-row'
  }
}

export function highlightRow(feature) {
  console.log('in highlightRow', feature)
  let id = feature.id_
  const tabName =
    feature.tabName ||
    feature.layer?.tocDisplayName ||
    feature.layer?.values_.displayName ||
    feature.layerName
  if (!id?.includes('-uid-')) id = tabName + '-uid-' + id
  const elem = document.getElementById(id)
  allRowsWhite()
  if (elem !== null) {
    selectRow(id)
  }
}

export function highlightInTable(props) {
  let id = props.feature?.id_ || props.id_
  let fid =
    props.feature?.values_?.vfid || props.values?.fid_ || props.values_?.fid_

  const { layer } = props.feature || props

  const tabName =
    props.feature?.tabName ||
    layer?.tocDisplayName ||
    layer?.values_?.displayName ||
    props.feature?.layerName ||
    layer?.tabName ||
    props.tabName
  const layerName =
    props.feature?.layerName ||
    layer?.name ||
    props.feature?.layer?.values_?.rebuildParams?.layerName ||
    layer?.values_?.rebuildParams?.layerName || props.layerName

  const activeTabName = window.items[window.activeTabIndex].name
  console.log('activeTabName', activeTabName)

  if (!id.includes('-uid-')) id = tabName + '-uid-' + id
  if (fid !== undefined) id = tabName + '-uid-' + layerName + '.' + fid
  console.log('id', id)
  if (tabName !== activeTabName) {
    window.emitter.emit('onTabClick', tabName, false)
  }
  setTimeout(() => {
    // vsetky riadky transparentne
    var tabRows_transparent = document.getElementsByClassName('tr'),
      index_t = tabRows_transparent.length
    while (index_t--) {
      tabRows_transparent[index_t].className = 'tr transparent-color'
    }
    // vsetky riadky biele
    var tabRows_white = document.getElementsByClassName('td'),
      index_w = tabRows_white.length
    while (index_w--) {
      tabRows_white[index_w].className = 'td white-color'
    }

    const elem = document.getElementById(id)
    const container = document.getElementById(
      'sc-attribute-table-tab-' + tabName
    )

    if (elem !== null) {
      var tabRow = document.getElementById(id).getElementsByClassName('td'),
        index_r = tabRow.length
      while (index_r--) {
        tabRow[index_r].className = 'td highlight-row'
      }
      const scrollPosition = elem.offsetTop - container.offsetTop - 7
      container.scrollTo({ top: scrollPosition, behavior: 'smooth' })
    } else {
      window.emitter.emit('addTableRow', tabName, layerName, id, fid)
      setTimeout(() => {
        var tabRow = document.getElementById(id).getElementsByClassName('td'),
          index_r = tabRow.length
        while (index_r--) {
          tabRow[index_r].className = 'td highlight-row'
        }
      }, 400)
    }
  }, 600)
}

export function removeMapControl(map, controlType) {
  const remove = (control) => {
    map.removeControl(control)
  }
  map.getControls().forEach(function (control) {
    if (controlType === 'zoom' && control instanceof Zoom) {
      remove(control)
    }
    if (controlType === 'rotate' && control instanceof Rotate) {
      remove(control)
    }
    if (controlType === 'fullscreen' && control instanceof FullScreen) {
      remove(control)
    }
    if (controlType === 'scaleLine' && control instanceof ScaleLine) {
      remove(control)
    }
  }, this)
}

export function addMapControl(map, controlType) {
  const add = (control) => {
    if (!hasMapControl(map, controlType)) map.addControl(control)
  }
  switch (controlType) {
    case 'rotate':
      add(new Rotate())
      break
    case 'zoom':
      add(new Zoom())
      break
    case 'fullscreen':
      add(new FullScreen())
      break
    case 'scaleLine':
      add(new ScaleLine({ minWidth: 100 }))
      break
    default:
      break
  }
}
function hasMapControl(map, controlType) {
  let returnResult = false
  map.getControls().forEach(function (control) {
    if (controlType === 'zoom' && control instanceof Zoom) {
      returnResult = true
    }
    if (controlType === 'rotate' && control instanceof Rotate) {
      returnResult = true
    }
    if (controlType === 'fullscreen' && control instanceof FullScreen) {
      returnResult = true
    }
    if (controlType === 'scaleLine' && control instanceof ScaleLine) {
      returnResult = true
    }
  }, this)
  return returnResult
}

export function TableDisplay(props) {
  const { info } = props
  if (info === null) return <div />
  return (
    <table>
      <tbody>
        <tr key={getUID()}>
          {Object.keys(info[0]).map((key) => (
            <th key={getUID()}>{key}</th>
          ))}
        </tr>
        {info.map((item) => (
          <tr key={getUID()}>
            {Object.values(item).map((val) => (
              <td
                key={getUID()}
                style={{ border: '1px solid black', padding: '5px 5px' }}
              >
                {val}
              </td>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  )
}

export function getBase64FromImageUrlWithParams(
  url,
  params = undefined,
  callback
) {
  var xhr = new XMLHttpRequest()
  xhr.open('GET', url)
  if (params !== undefined) {
    for (const [key, value] of Object.entries(params)) {
      xhr.setRequestHeader(key, value)
    }
  }

  xhr.onload = function () {
    var response = xhr.responseText
    var binary = ''

    for (var i = 0; i < response.length; i++) {
      binary += String.fromCharCode(response.charCodeAt(i) & 0xff)
    }
    var img = new Image()

    img.setAttribute('crossOrigin', 'anonymous')

    img.onload = function () {
      var canvas = document.createElement('canvas')
      canvas.width = this.width
      canvas.height = this.height

      var ctx = canvas.getContext('2d')
      ctx.drawImage(this, 0, 0)

      var dataURL = canvas.toDataURL('image/png')

      callback(this.height, dataURL)
    }

    img.src = 'data:image/png;base64,' + btoa(binary)
  }
  xhr.overrideMimeType('text/plain; charset=x-user-defined')
  xhr.send()
}

export function getBase64FromImageUrl(url, callback) {
  var img = new Image()

  img.setAttribute('crossOrigin', 'anonymous')

  img.onload = function () {
    var canvas = document.createElement('canvas')
    canvas.width = this.width
    canvas.height = this.height

    var ctx = canvas.getContext('2d')
    ctx.drawImage(this, 0, 0)

    var dataURL = canvas.toDataURL('image/png')

    //var data = dataURL.replace(/^data:image\/(png|jpg);base64,/, "");
    callback(this.height, dataURL)
  }

  img.src = url
}

export function waitForLoad(
  items,
  startTime = Date.now(),
  timeout = 30,
  callback
) {
  if (startTime + timeout * 1000 <= Date.now()) {
    showMessage(
      'Upozornenie',
      'Položky sa nepodarilo načítať včas. Načítajte stránku znova',
      messageColors.red,
      5000
    )
    console.error('timeout loading', items)
  } else {
    if (isLoaded(items)) {
      //console.log("wait for load", items, Date.now() - startTime);
      callback()
    } else {
      setTimeout(() => waitForLoad(items, startTime, timeout, callback), 50)
    }
  }
}
export function isLoaded(items) {
  if (Array.isArray(items)) {
    let returnResult = true
    items.forEach((item) => {
      if (returnResult)
        returnResult = window.loaded.includes(item.toLowerCase())
    })
    return returnResult
  } else {
    return window.loaded.includes(items.toLowerCase())
  }
}
export function addIsLoaded(item) {
  if (!window.loaded.includes(item.toLowerCase()))
    window.loaded.push(item.toLowerCase())
}
export function removeIsLoaded(item) {
  if (window.loaded.includes(item.toLowerCase()))
    window.loaded.splice(window.loaded.indexOf(item.toLowerCase()), 1)
}

export function loadConfig(callback) {
  const storageMapDefaultsKey = 'Map Defaults'
  //url parameters
  //local config
  //settings api
  //local storage

  //get url parameters
  let config = mainConfig
  //let localSettings = localStorage;
  //config = mergeObj(config, localSettings);

  let queryString = window.location.search
  if (config.useWebminDefault) {
    if (queryString.includes('WEBMIN') === false) queryString += '&WEBMIN=' + (config.appName || 'webmin')
  }
  let mapId = null
  let urlWebmin = null
  let urlAppka = null
  let loaderType = 'DEFAULT' //MAPID, ARCGIS, GEOSERVER
  let geoserverUrl = config.toc.geoserverLayerGroupsUrl
  let geoserverUrlType = config.toc.geoserverLayerGroupsUrlType
  let tocType = config.toc.tocType

  let esriServiceUrl = config.toc.esriServiceUrl
  if (queryString.length > 0) {
    const urlParams = new URLSearchParams(queryString)
    const url_mapId = urlParams.get('MAP_ID')
    const url_geoserverUrlType = urlParams.get('GEO_TYPE')
    const url_tocType = urlParams.get('TOCTYPE')
    const url_geoserverUrl = urlParams.get('GEO_URL')
    const url_esriServiceUrl = urlParams.get('ARCGIS_SERVICE')
    const url_zaznam = urlParams.get('zaznam')
    const url_webmin = urlParams.get('WEBMIN')
    const url_appka = urlParams.get('APPKA')
    const viewerMode = urlParams.get('MODE')
    if (url_webmin !== null) {
      urlWebmin = url_webmin
      config.appName = url_webmin
    }
    if (url_appka !== null) {
      urlAppka = url_appka
    }
    if (url_zaznam !== null) {
      console.log('url_zaznam', url_zaznam)
      getJSONWait(
        mainConfig.apiUrlEsprit + 'ZAZNAM/' + url_zaznam,
        //"https://192.168.1.37:3001/kataster/parcelac/810649/2790%2f14",
        (data) => {
          console.log('data', data)
          if (!data[0].geom) return

          // window.datose = getFeatureFromGeoJSON(data[0].geom);
          //zoomToFeature(getFeatureFromGeoJSON(data[0].geom));
          config['zaznam'] = data
          // config["zaznam"] = data[0];
          //   config["zaznam"] = getFeatureFromGeoJSON(data[0].geom);

          //   let feature = getFeatureFromGeoJSON(data[0].geom);
          //   feature.values_ = data[0];

          //   const uniqueFilterName = vHelpers.getUniqueName(
          //       "Zaznam",
          //       null,
          //       vHelpers.extractUsedFilterNames(window.config.storageKeyFilterResults)
          //     );

          //     window.emitter.emit(
          //         "openAttTabGEOJSON",
          //         uniqueFilterName,
          //         uniqueFilterName,
          //         feature,
          //         uniqueFilterName,
          //         "uri"
          //       );
        }
      )
    } else {
      // console.log("url_zaznam === null");
    }

    if (url_geoserverUrlType !== null) geoserverUrlType = url_geoserverUrlType
    if (url_mapId !== null) {
      mapId = url_mapId.toLowerCase()
      loaderType = 'MAPID'
      config['mapId'] = mapId
    }
    if (viewerMode !== null) {
      config['viewerMode'] = viewerMode
    }
    if (url_geoserverUrl !== null) {
      geoserverUrl = url_geoserverUrl
      loaderType = 'GEOSERVER'
    }
    if (url_esriServiceUrl !== null) {
      esriServiceUrl = url_esriServiceUrl
      loaderType = 'ARCGIS'
    }
    if (url_tocType !== null) tocType = url_tocType
  }

  if (tocType !== config.toc.tocType) config.toc['tocType'] = tocType
  if (geoserverUrl !== config.toc.geoserverLayerGroupsUrl) {
    if (!geoserverUrl.toLowerCase().includes('request=GetCapabilities'))
      geoserverUrl = `${geoserverUrl}/ows?service=wms&version=1.3.0&request=GetCapabilities`
    config.toc['geoserverLayerGroupsUrl'] = geoserverUrl
  }
  if (geoserverUrlType !== config.toc.geoserverLayerGroupsUrlType)
    config.toc['geoserverLayerGroupsUrlType'] = geoserverUrlType
  if (esriServiceUrl !== config.toc.esriServiceUrl)
    config.toc['esriServiceUrl'] = esriServiceUrl

  if (loaderType === 'DEFAULT') {
    if (mapId !== null && mapId !== undefined && mapId.trim() !== '') {
      config['mapId'] = mapId
      loaderType = 'MAPID'
    } else if (
      geoserverUrl !== null &&
      geoserverUrl !== undefined &&
      geoserverUrl.trim() !== ''
    ) {
      loaderType = 'GEOSERVER'
    } else if (
      esriServiceUrl !== null &&
      esriServiceUrl !== undefined &&
      esriServiceUrl.trim() !== ''
    ) {
      loaderType = 'ARCGIS'
    }
  }
  console.log(urlWebmin)

  config.toc['loaderType'] = loaderType
  if (mapId === null) mapId = config.mapId
  if (urlAppka !== null) {
    getJSONWait('./' + urlAppka, (data) => {
      window.config = data
      setUrlSettings()
      callback()
    })
  }
  if (urlWebmin !== null) {
    getJSONWait(
      mainConfig.apiUrlEsprit + '/admin/getApp/' + urlWebmin,
      (data) => {
        config = mergeObj(config, data)
        setUrlSettings()
        callback()
      }
    )
  }
  if (
    config.useMapConfigApi ||
    (mapId !== null && mapId !== undefined && mapId.trim() !== '')
  ) {
    console.log('tu loadertype setne na mapid')
    config.toc['loaderType'] = 'MAPID'
    const mapSettingURL = (apiUrlEsprit, mapId) => {
      if (mapId === null || mapId === undefined || mapId.trim() === '')
        return `${apiUrlEsprit}settings/getDefaultMap`
      else return `${apiUrlEsprit}getMap?id=${mapId}`
    }
    getJSON(mapSettingURL(config.apiUrlEsprit, mapId), (result) => {
      if (result.json === undefined) {
        setTimeout(() => {
          showMessage(
            'Upozornenie',
            'Nepodarilo sa načítať ID mapy',
            messageColors.red
          )
        }, 5000)
        //        window.config = config;
        callback()
      }
      const settings = result

      if (settings.name !== undefined) document.title = settings.name
      if (settings.zoom_level !== undefined) {
        settings['defaultZoom'] = settings.zoom_level
        delete settings.zoom_level
      }
      if (settings.center !== undefined) {
        settings['centerCoords'] = Array.isArray(settings.center)
          ? settings.center
          : settings.center.replace(' ', '').split(',')
        delete settings.center
      }
      sessionStorage.setItem(
        storageMapDefaultsKey,
        JSON.stringify({
          center: settings.centerCoords,
          zoom: settings.defaultZoom
        })
      )
      if (settings.sidebarToolComponents !== undefined)
        settings.sidebarToolComponents = mergeObjArray(
          config.sidebarToolComponents,
          settings.sidebarToolComponents
        )
      if (settings.sidebarThemeComponents !== undefined)
        settings.sidebarThemeComponents = mergeObjArray(
          config.sidebarThemeComponents,
          settings.sidebarThemeComponents
        )
      if (settings.sidebarShortcutParams !== undefined)
        settings.sidebarShortcutParams = mergeObjArray(
          config.sidebarShortcutParams,
          settings.sidebarShortcutParams
        )
      // if (settings.baseMapType !== undefined) settings.baseMapType = config.baseMapType;
      // if (settings.baseMapServices !== undefined) settings.baseMapServices = mergeObjArray(config.baseMapServices, settings.baseMapServices);

      //TRANSPOSE LEGACY TOC SETTINGS
      if (settings.toc === undefined) settings['toc'] = {}
      if (settings.default_toc_style !== undefined) {
        settings.toc['tocType'] = settings.default_toc_style
        delete settings.default_toc_style
      }

      if (settings.default_group !== undefined) {
        settings.toc['default_group'] = settings.default_group
        delete settings.default_group
      }
      if (settings.sources !== undefined) {
        settings.toc['sources'] = settings.sources
        delete settings.sources
      }

      //TODO: OVERRIDE INDIVIDUAL THEME, TOOL, OR BASEMAP SETTINGS????
      config = mergeObj(config, settings)
      window.config = config
      callback()
    })
  } else {
  }
}
export function setUrlSettings() {
  document.title = window.config.title
}
export function getConfig(component, name) {
  let configArray = []
  switch (component.toLowerCase()) {
    case 'tools':
      configArray = window.config['sidebarToolComponents']
      break
    case 'themes':
      configArray = window.config['sidebarThemeComponents']
      break
    default:
      break
  }
  return configArray.filter(
    (item) =>
      item.name !== undefined && item.name.toLowerCase() === name.toLowerCase()
  )[0]
}

export function mergeObjArray(targetArray, sourceArray) {
  let resultArray = []
  targetArray.forEach((targetObj) => {
    let sourceObj = sourceArray.filter(
      (source) => targetObj.id === source.id
    )[0]
    if (sourceObj !== undefined) {
      resultArray.push(mergeObj(targetObj, sourceObj))
      sourceArray = sourceArray.filter((source) => sourceObj.id !== source.id)
    } else resultArray.push(targetObj)
  })
  return resultArray.concat(sourceArray)
}
export function mergeObj(targetObj, sourceObj) {
  Object.keys(sourceObj).forEach((key) => {
    if (
      typeof targetObj[key] === 'object' &&
      !(targetObj[key] instanceof Array)
    ) {
      targetObj[key] = mergeObj(targetObj[key], sourceObj[key])
    } else {
      targetObj[key] = sourceObj[key]
    }
  })
  return targetObj
}

export function extentHistory(action, center = undefined, zoom = undefined) {
  const mapExtentHistoryKey = 'mapExtentHistory'
  const mapExtentHistoryCurrentKey = 'mapExtentHistoryCurrent'
  let index = parseInt(sessionStorage.getItem(mapExtentHistoryCurrentKey))
  let extents =
    sessionStorage.getItem(mapExtentHistoryKey) === null
      ? []
      : JSON.parse(sessionStorage.getItem(mapExtentHistoryKey))

  switch (action) {
    case 'init':
      sessionStorage.setItem(
        mapExtentHistoryKey,
        JSON.stringify([{ center: center, zoom: zoom }])
      )
      sessionStorage.setItem(mapExtentHistoryCurrentKey, 0)
      break
    case 'save':
      if (!zoom) zoom = window.map.getView().getZoom()
      if (!center) center = window.map.getView().getCenter()
      const currentExtentItem = extents[index]
      if (
        currentExtentItem.zoom !== zoom ||
        (currentExtentItem.center[0] !== center[0] &&
          currentExtentItem.center[1] !== center[1])
      ) {
        index++
        extents.push({ center: center, zoom: zoom })
        sessionStorage.setItem(mapExtentHistoryKey, JSON.stringify(extents))
        sessionStorage.setItem(mapExtentHistoryCurrentKey, index)
      }

      break
    case 'next':
      if (index === extents.length - 1) return
      if (extents[index + 1] !== undefined) {
        sessionStorage.setItem(mapExtentHistoryCurrentKey, index + 1)
        window.map.getView().setZoom(extents[index + 1].zoom)
        window.map.getView().setCenter(extents[index + 1].center)
      }
      break
    case 'previous':
      if (index === 0) return
      if (extents[index - 1] !== undefined) {
        sessionStorage.setItem(mapExtentHistoryCurrentKey, index - 1)
        window.map.getView().setZoom(extents[index - 1].zoom)
        window.map.getView().setCenter(extents[index - 1].center)
      }
      break
    default:
      break
  }
  window.emitter.emit('extentHistoryChanged', index, extents.length)
}
export function getARNListFromGeom(geom, callback) {
  const arnURLTemplate = (mainURL, wkt) =>
    `${mainURL}&cql_filter=INTERSECTS(geom,${wkt})`

  const feature = new Feature(geom)
  const wktString = getWKTStringFromFeature(feature)
  const parcelURL = arnURLTemplate(window.config.parcelLayer.url, wktString)

  const tmpArnArray = []
  getJSON(parcelURL, (result) => {
    if (result.features.length === 0) return
    const features = result.features
    features.forEach((feature) => {
      tmpArnArray.push(
        feature.properties[
          window.config.parcelLayer.rollNumberFieldName.toLowerCase()
        ]
      )
    })

    callback(tmpArnArray)
  })
}
export function getFeaturesFromGeom(wfsUrl, geomFieldName, geom, callback) {
  const urlTemplate = (mainURL, geomField, wkt) =>
    `${mainURL}&cql_filter=INTERSECTS(${geomField},${wkt})`
  bufferGeometry(geom, -1, (resultGeom) => {
    const feature = new Feature(resultGeom)
    const wktString = getWKTStringFromFeature(feature)
    const queryUrl = urlTemplate(wfsUrl, geomFieldName, wktString)
    getJSON(queryUrl, (result) => {
      if (result.features.length === 0) callback([])
      else {
        const features = new GeoJSON().readFeatures(result)
        callback(features)
      }
    })
  })
}